<div id="commission-summary-container" *ngIf="this.data">
  <div class="title-container">
    <p class="heading-02-bold grey-900">Comisiones</p>
  </div>
  <ng-container *ngIf="!this.data.referred.isReferred">
    <!-- Precio de cierre -->
    <div class="row show-row">
      <div class="row-header">
        <div class="row-titles">
          <div class="icon-container">
            <qr-icon name="properties" color="primary-700"></qr-icon>
          </div>
          <p class="subheading-01-semi-bold grey-800">Precio de cierre</p>
        </div>
        <div class="row-currencies">
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.closedPrice.usd"
          >
            U$S {{ (this.data.closedPrice.usd | number: "1.0-2") || 0 }}
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.closedPrice.local"
          >
            $ {{ (this.data.closedPrice.local | number: "1.0-2") || 0 }}
          </p>
        </div>
      </div>
    </div>
    <!-- Precio de cierre -->

    <!-- Comisión bruta -->
    <div
      class="row"
      *ngIf="this.data.rawCommission.percentage > 0"
      [ngClass]="{ 'show-row': this.data.rawCommission.percentage > 0 }"
    >
      <div class="row-header">
        <div class="row-titles">
          <div class="icon-container">
            <qr-icon name="money" color="primary-700"></qr-icon>
          </div>
          <p class="subheading-01-semi-bold grey-800">Comisión bruta</p>
        </div>
        <div class="row-currencies">
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.rawCommission.percentage"
          >
            {{ (this.data.rawCommission.percentage | number: "1.0-2") || 0 }}%
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.rawCommission.usd"
          >
            U$S {{ (this.data.rawCommission.usd | number: "1.0-2") || 0 }}
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.rawCommission.local"
          >
            $ {{ (this.data.rawCommission.local | number: "1.0-2") || 0 }}
          </p>
        </div>
      </div>
    </div>
    <!-- Comisión bruta -->

    <!-- Punta Vendedora -->
    <div
      class="row"
      *ngIf="this.data.seller.percentage > 0"
      [ngClass]="{
        'show-row': this.data.seller.percentage > 0,
        'border-none': this.data.seller.percentage > 0
      }"
    >
      <div class="row-header">
        <div class="row-titles">
          <div class="icon-container">
            <qr-icon name="agent" color="primary-700"></qr-icon>
          </div>
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="subheading-01-semi-bold grey-800"
          >
            Punta vendedora
            <span class="grey-600"
              >({{ (this.data.seller.relation | number: "1.0-2") || 0 }}%)</span
            >
          </p>
          <p *ifNodeShow="[NODE_DO]" class="subheading-01-semi-bold grey-800">
            Punta captadora
            <span class="grey-600"
              >({{ (this.data.seller.relation | number: "1.0-2") || 0 }}%)</span
            >
          </p>
        </div>
        <div class="row-currencies">
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.seller.percentage > 0"
          >
            {{ (this.data.seller.percentage | number: "1.0-2") || 0 }}%
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="
              this.data.seller.percentage > 0 && this.data.rawCommission.usd
            "
          >
            U$S
            {{
              this.data.seller.usd +
                (!this.data.seller.officeId &&
                !this.data.seller.otherRealEstateName
                  ? this.cobrokerInitVisualUSD
                  : 0) || 0 | number: "1.0-2"
            }}
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="
              this.data.seller.percentage > 0 && this.data.rawCommission.local
            "
          >
            $
            {{
              this.data.seller.local +
                (!this.data.seller.officeId &&
                !this.data.seller.otherRealEstateName
                  ? this.cobrokerInitVisualLocal
                  : 0) || 0 | number: "1.0-2"
            }}
          </p>
        </div>
      </div>

      <!-- Agente Vendedor -->
      <div
        class="summary first"
        [ngClass]="{ 'show-row': this.data.seller.agent.name }"
        *ngIf="this.data.seller.agent.name"
      >
        <div
          class="summary-header"
          (click)="this.sellerAgentBox()"
          [ngClass]="{
            'border-bottom': this.sellerAgentShow,
            'height-summary':
              this.data.seller.officeId != null ||
              this.data.seller.otherRealEstateName != null
          }"
        >
          <div class="left-info">
            <div
              class="icon-arrow-container"
              *ngIf="
                this.data.seller.officeId == null &&
                this.data.seller.otherRealEstateName == null
              "
            >
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.sellerAgentShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Agente: {{ this.data.seller.agent.name }}
              </p>
              <p
                class="caption-01-semi-bold grey-500"
                *ngIf="this.data.seller.officeId != null"
              >
                (RE/MAX {{ this.data.seller.agent.office }})
              </p>
              <p
                *ngIf="this.data.seller.otherRealEstateName != null"
                class="caption-01-semi-bold grey-500"
              >
                ({{ this.data.seller.otherRealEstateName }})
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="
              !this.sellerAgentShow ||
              this.data.seller.officeId != null ||
              this.data.seller.otherRealEstateName != null
            "
            [ngClass]="{
              end:
                this.data.seller.agent.netCommission.usd == 0 ||
                this.data.seller.agent.netCommission.local == 0 ||
                (NODE === NODE_DO && this.data.seller.percentage > 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.agent.netCommission.usd > 0 ||
                (NODE === NODE_DO && this.data.rawCommission.usd)
              "
            >
              U$S
              {{
                (this.data.seller.agent.netCommission.usd - this.cobrokerUSD
                  | number: "1.0-2") || 0
              }}
            </p>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.agent.netCommission.local > 0 ||
                (NODE === NODE_DO && this.data.rawCommission.local)
              "
            >
              $
              {{
                (this.data.seller.agent.netCommission.local - this.cobrokerLocal
                  | number: "1.0-2") || 0
              }}
            </p>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: this.sellerAgentShow }"
          *ngIf="this.sellerAgentShow"
        >
          <div
            class="deductions"
            *ngIf="
              !this.data.seller.officeId &&
              !this.data.seller.otherRealEstateName
            "
          >
            <!-- Comision Bruta Agente -->
            <div
              class="deductions-row"
              *ngIf="
                this.data.seller.usd ||
                this.data.seller.local ||
                (NODE === NODE_DO && this.data.seller.percentage > 0)
              "
              [ngClass]="{
                'show-row-item':
                  this.data.seller.usd ||
                  this.data.seller.local ||
                  (NODE === NODE_DO && this.data.seller.percentage > 0)
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    !this.data.seller.usd ||
                    !this.data.seller.local ||
                    (NODE === NODE_DO && this.data.seller.percentage > 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.usd ||
                    (NODE === NODE_DO && this.data.rawCommission.usd)
                  "
                >
                  U$S {{ (this.data.seller.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.local ||
                    (NODE === NODE_DO && this.data.rawCommission.local)
                  "
                >
                  $ {{ (this.data.seller.local | number: "1.0-2") || 0 }}
                </p>
              </div>
            </div>
            <!-- Deduccion Manual -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.agent.manualDeduction.name &&
                  (this.data.seller.agent.manualDeduction.usd > 0 ||
                    this.data.seller.agent.manualDeduction.local > 0)
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción: {{ this.data.seller.agent.manualDeduction.name }}
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (!this.data.seller.agent.manualDeduction.usd ||
                      !this.data.seller.agent.manualDeduction.local) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.agent.manualDeduction.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.agent.manualDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.agent.manualDeduction.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.agent.manualDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Referido -->
            <div
              class="deductions-row"
              *ngIf="
                (this.data.seller.referred.name ||
                  this.data.seller.referred.officeId) &&
                this.data.seller.referred.rawCommission.percentage > 0
              "
              [ngClass]="{
                'show-row-item':
                  (this.data.seller.referred.name ||
                    this.data.seller.referred.officeId) &&
                  this.data.seller.referred.rawCommission.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Referido
                  <span class="grey-500"
                    >({{
                      this.data.seller.referred.rawCommission.percentage
                        | number: "1.0-2"
                    }}%)</span
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (!this.data.seller.referred.rawCommission.usd ||
                      !this.data.seller.referred.rawCommission.local) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.rawCommission.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.rawCommission.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Agente Primer Subtotal -->
            <div
              class="deductions-row subtotal"
              *ngIf="
                this.data.seller.officeId == null &&
                this.data.seller.otherRealEstateName == null &&
                (this.data.seller.agent.firstSubtotal.usd > 0 ||
                  this.data.seller.agent.firstSubtotal.local > 0)
              "
              [ngClass]="{
                'show-row-item':
                  this.data.seller.officeId == null &&
                  this.data.seller.otherRealEstateName == null
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Subtotal</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.agent.firstSubtotal.usd == 0 ||
                      this.data.seller.agent.firstSubtotal.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.seller.agent.firstSubtotal.usd &&
                    this.data.seller.agent.firstSubtotal.usd >= 0
                  "
                >
                  U$S
                  {{
                    this.data.seller.agent.firstSubtotal.usd | number: "1.0-2"
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.seller.agent.firstSubtotal.local &&
                    this.data.seller.agent.firstSubtotal.local >= 0
                  "
                >
                  $
                  {{
                    this.data.seller.agent.firstSubtotal.local | number: "1.0-2"
                  }}
                </p>
              </div>
            </div>
            <!-- Team Leader -->
            <div
              class="deductions-row"
              *ngIf="showSplitSeller"
              [ngClass]="{
                'show-row-item': showSplitSeller
              }"
            >
              <div class="titles">
                <p
                  *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                  class="paragraph-03-regular grey-700"
                >
                  Team Leader
                </p>

                <p
                  *ifNodeShow="[NODE_DO]"
                  class="paragraph-03-regular grey-700"
                >
                  <ng-container
                    *ngIf="
                      this.data.seller.teamLeader.rawCommission.usd > 0 ||
                        this.data.seller.teamLeader.rawCommission.local > 0;
                      else sellerDoOfficeDiscount
                    "
                  >
                    T. Leader
                    ({{
                      100 -
                        this.dataAgentTypes[this.data.seller.agent.type.name]
                    }}% )
                  </ng-container>
                  <ng-template #sellerDoOfficeDiscount>
                    Desc. Oficina
                    <strong>
                      {{
                        100 -
                          this.dataAgentTypes[this.data.seller.agent.type.name]
                      }}%
                    </strong>
                    <span
                      class="grey-500"
                      *ngIf="
                        this.data.seller.agent.type.name === 'TEAM_JUNIOR';
                        else sellerDoOfficeNotTeamJunior
                      "
                    >
                      (T. Member
                      {{
                        this.dataAgentTypes[this.data.seller.agent.type.name]
                      }}%)</span
                    >
                    <ng-template #sellerDoOfficeNotTeamJunior>
                      <span
                        class="grey-600"
                        *ngIf="
                          this.data.seller.agent.type.name ==
                            'AGENTE_CIEN_PORCIENTO';
                          else sellerDoOfficeCommonAgent
                        "
                      >
                        (Agente
                        {{
                          this.dataAgentTypes[this.data.seller.agent.type.name]
                        }}%)</span
                      >
                      <ng-template #sellerDoOfficeCommonAgent>
                        <span class="grey-600">
                          ({{
                            this.data.seller.agent.type.original | capitalize
                          }}
                          {{
                            this.dataAgentTypes[
                              this.data.seller.agent.type.name
                            ]
                          }}%)</span
                        >
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </p>
              </div>
              <ng-container
                *ngIf="
                  this.data.seller.teamLeader.rawCommission.usd > 0 ||
                  this.data.seller.teamLeader.rawCommission.local > 0
                "
              >
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.seller.teamLeader.rawCommission.usd == 0 ||
                        this.data.seller.teamLeader.rawCommission.local == 0) &&
                      (this.data.seller.usd == 0 || this.data.seller.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="
                      this.data.seller.teamLeader.rawCommission.usd &&
                      this.data.seller.teamLeader.rawCommission.usd >= 0
                    "
                  >
                    - U$S
                    {{
                      (this.data.seller.teamLeader.rawCommission.usd
                        | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="
                      this.data.seller.teamLeader.rawCommission.local &&
                      this.data.seller.teamLeader.rawCommission.local >= 0
                    "
                  >
                    - $
                    {{
                      (this.data.seller.teamLeader.rawCommission.local
                        | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.data.seller.teamLeader.rawCommission.usd === 0 &&
                  this.data.seller.teamLeader.rawCommission.local === 0 &&
                  (this.data.seller.agent.type.usd > 0 ||
                    this.data.seller.agent.type.local > 0)
                "
              >
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.seller.agent.type.usd == 0 ||
                        this.data.seller.agent.type.local == 0) &&
                      (this.data.seller.usd == 0 || this.data.seller.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="this.data.seller.agent.type.usd > 0"
                  >
                    - U$S
                    {{
                      (this.data.seller.agent.type.usd | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="this.data.seller.agent.type.local > 0"
                  >
                    - $
                    {{
                      (this.data.seller.agent.type.local | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </ng-container>
            </div>
            <!-- Agente Segundo Subtotal -->
            <div
              class="deductions-row subtotal"
              *ngIf="
                (this.NODE !== this.NODE_DO &&
                  (this.data.seller.teamLeader.rawCommission.usd > 0 ||
                    this.data.seller.teamLeader.rawCommission.local > 0)) ||
                (this.NODE === this.NODE_DO &&
                  this.data.seller.agent.deduction.percentage > 0)
              "
              [ngClass]="{
                'show-row-item':
                  data.seller.teamLeader.rawCommission.usd > 0 ||
                  data.seller.teamLeader.rawCommission.local > 0,
                'no-border-subtotal':
                  (data.seller.agent.secondSubtotal.usd > 0 ||
                    data.seller.agent.secondSubtotal.local > 0) &&
                  (data.seller.agent.type.usd === 0 ||
                    data.seller.agent.type.local === 0)
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Subtotal</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.teamLeader.rawCommission.usd == 0 ||
                      this.data.seller.teamLeader.rawCommission.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.seller.teamLeader.rawCommission.usd &&
                    this.data.seller.teamLeader.rawCommission.usd >= 0
                  "
                >
                  U$S
                  {{
                    (this.data.seller.agent.secondSubtotal.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.seller.teamLeader.rawCommission.local &&
                    this.data.seller.teamLeader.rawCommission.local >= 0
                  "
                >
                  $
                  {{
                    (this.data.seller.agent.secondSubtotal.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <ng-container *ngIf="this.NODE !== this.NODE_DO">
              <div
                class="deductions-row"
                [ngClass]="{
                  'show-row-item':
                    (this.data.seller.agent.secondSubtotal.usd > 0 ||
                      this.data.seller.agent.secondSubtotal.local > 0) &&
                    (this.data.seller.agent.type.usd > 0 ||
                      this.data.seller.agent.type.local > 0)
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">
                    Desc. Oficina
                    <strong>
                      {{
                        100 -
                          this.dataAgentTypes[this.data.seller.agent.type.name]
                      }}%
                    </strong>
                    <span
                      class="grey-500"
                      *ngIf="
                        this.data.seller.agent.type.name === 'TEAM_JUNIOR';
                        else noteamjunior
                      "
                    >
                      (T. Member
                      {{
                        this.dataAgentTypes[this.data.seller.agent.type.name]
                      }}%)</span
                    >
                    <ng-template #noteamjunior>
                      <span
                        class="grey-600"
                        *ngIf="
                          this.data.seller.agent.type.name ==
                            'AGENTE_CIEN_PORCIENTO';
                          else sellercommonagent
                        "
                      >
                        (Agente
                        {{
                          this.dataAgentTypes[this.data.seller.agent.type.name]
                        }}%)</span
                      >
                      <ng-template #sellercommonagent>
                        <span
                          *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                          class="grey-600"
                        >
                          ({{ this.data.seller.agent.type.name }}
                          {{
                            this.dataAgentTypes[
                              this.data.seller.agent.type.name
                            ]
                          }}%)</span
                        >
                      </ng-template>
                    </ng-template>
                  </p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.seller.agent.secondSubtotal.usd == 0 ||
                        this.data.seller.agent.secondSubtotal.local == 0) &&
                      (this.data.seller.usd == 0 || this.data.seller.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="
                      this.data.seller.agent.secondSubtotal.usd >= 0 &&
                      this.data.seller.usd > 0
                    "
                  >
                    - U$S
                    {{
                      (this.data.seller.agent.type.usd | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="
                      this.data.seller.agent.secondSubtotal.local >= 0 &&
                      this.data.seller.local > 0
                    "
                  >
                    - $
                    {{
                      (this.data.seller.agent.type.local | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>
            </ng-container>
            <!-- Deduccion agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.agent.deduction &&
                  this.data.seller.agent.deduction.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.seller.agent.deduction.percentage
                        | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.agent.deduction.usd > 0 ||
                      this.data.seller.agent.deduction.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.agent.deduction.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.agent.deduction.usd | number: "1.0-2") ||
                      0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.agent.deduction.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.agent.deduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- ABAO Vendedora -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.agent.abao.usd > 0 ||
                  this.data.seller.agent.abao.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Agente a Oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.agent.abao.usd > 0 ||
                      this.data.seller.agent.abao.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.agent.abao.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{ (this.data.seller.agent.abao.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.agent.abao.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.agent.abao.local | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Agente -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.agent.netCommission.usd > 0 ||
                  this.data.seller.agent.netCommission.local > 0 ||
                  (NODE === NODE_DO && this.data.seller.percentage > 0)
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    ((this.data.seller.usd || this.data.seller.local) &&
                      (this.data.seller.usd == 0 ||
                        this.data.seller.local == 0)) ||
                    (NODE === NODE_DO && this.data.seller.percentage > 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.seller.usd > 0 ||
                    (NODE === NODE_DO && this.data.rawCommission.usd)
                  "
                >
                  U$S
                  {{
                    this.data.seller.agent.netCommission.usd | number: "1.0-2"
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.seller.local > 0 ||
                    (NODE === NODE_DO && this.data.rawCommission.local)
                  "
                >
                  $
                  {{
                    this.data.seller.agent.netCommission.local | number: "1.0-2"
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>

    <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Agente Vendedor END -->

      <!-- Referido Vendedor -->
      <div
        class="summary"
        *ngIf="
          ((this.data.seller.referred.name &&
            this.data.seller.referred.rawCommission.percentage) ||
            this.data.seller.referred.officeId) &&
          this.data.seller.agent.office
        "
        [ngClass]="{
          'show-row':
            (this.data.seller.referred.name ||
              this.data.seller.referred.officeId) &&
            this.data.seller.agent.office
        }"
      >
        <div
          class="summary-header"
          (click)="this.sellerReferredBox()"
          [ngClass]="{
            'border-bottom': this.sellerReferredShow,
            'height-summary': this.data.seller.referred.officeId
          }"
        >
          <div class="left-info">
            <div
              class="icon-arrow-container"
              *ngIf="!this.data.seller.referred.officeId"
            >
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.sellerReferredShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Referido: {{ this.data.seller.referred.name || "-" }}
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.seller.referred.officeId &&
                  this.data.seller.referred.officeId !=
                    this.data.seller.referred.name &&
                  this.data.seller.referred.officeId != '(Otra inmobiliaria)'
                "
              >
                (RE/MAX {{ this.data.seller.referred.officeId }})
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.seller.referred.officeId &&
                  (this.data.seller.referred.officeId ==
                    this.data.seller.referred.name ||
                    this.data.seller.referred.officeId == '(Otra inmobiliaria)')
                "
              >
                (Otra Inmobiliaria)
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="
              !this.sellerReferredShow ||
              (this.data.seller.referred.officeId &&
                this.data.seller.agent.office)
            "
            [ngClass]="{
              end:
                (this.data.seller.referred.netCommission.usd == 0 ||
                  this.data.seller.referred.netCommission.local == 0) &&
                (this.data.seller.usd == 0 || this.data.seller.local == 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.referred.netCommission.usd > 0 &&
                  this.data.seller.usd > 0;
                else sellerreferredusdraw
              "
            >
              U$S
              {{
                (this.data.seller.referred.netCommission.usd
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #sellerreferredusdraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.seller.referred.rawCommission.usd > 0 &&
                  this.data.seller.usd > 0
                "
              >
                U$S
                {{
                  (this.data.seller.referred.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.referred.netCommission.local > 0 &&
                  this.data.seller.local > 0;
                else sellerreferredlocalraw
              "
            >
              $
              {{
                (this.data.seller.referred.netCommission.local
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #sellerreferredlocalraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.seller.referred.rawCommission.local > 0 &&
                  this.data.seller.local > 0
                "
              >
                U$S
                {{
                  (this.data.seller.referred.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: !this.data.seller.referred.officeId }"
          *ngIf="!this.data.seller.referred.officeId && this.sellerReferredShow"
        >
          <div class="deductions">
            <!-- Comision Bruta Referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.rawCommission.usd > 0 ||
                  this.data.seller.referred.rawCommission.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.rawCommission.usd == 0 ||
                      this.data.seller.referred.rawCommission.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.rawCommission.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  U$S
                  {{
                    (this.data.seller.referred.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.rawCommission.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  $
                  {{
                    (this.data.seller.referred.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.rawCommission.usd > 0 ||
                  this.data.seller.referred.rawCommission.local > 0
              }"
              *ngIf="
                this.data.seller.referred.rawCommission.usd > 0 ||
                this.data.seller.referred.rawCommission.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.seller.referred.type.name === ""
                            ? this.data.seller.referred.type.original
                            : this.data.seller.referred.type.name
                        ]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.seller.referred.type.name == 'TEAM_JUNIOR';
                      else noteamjuniorreferred
                    "
                  >
                    (T. Member
                    {{
                      this.dataAgentTypes[this.data.seller.referred.type.name]
                    }}%)</span
                  >
                  <ng-template #noteamjuniorreferred>
                    <span
                      class="grey-600"
                      *ngIf="
                        this.data.seller.referred.type.name ==
                          'AGENTE_CIEN_PORCIENTO';
                        else commonagentbuyerreferred
                      "
                    >
                      (Agente
                      {{
                        this.dataAgentTypes[
                          this.data.seller.referred.type.name
                        ]
                      }}%)</span
                    >

                    <ng-template #commonagentbuyerreferred>
                      <span
                        *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                        class="grey-600"
                      >
                        ({{ this.data.seller.referred.type.name }}
                        {{
                          this.dataAgentTypes[
                            this.data.seller.referred.type.name
                          ]
                        }}%)</span
                      >
                      <span *ifNodeShow="[NODE_DO]" class="grey-600">
                        ({{
                          this.data.seller.referred.type.original | capitalize
                        }}
                        {{
                          this.dataAgentTypes[
                            this.data.seller.referred.type.name
                          ]
                        }}%)</span
                      >
                    </ng-template>
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.rawCommission.usd == 0 ||
                      this.data.seller.referred.rawCommission.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.rawCommission.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.type.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.rawCommission.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.type.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.agentDeduction.usd > 0 ||
                  this.data.seller.referred.agentDeduction.local > 0
              }"
              *ngIf="this.data.seller.referred.agentDeduction.percentage > 0"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.seller.referred.agentDeduction.percentage
                        | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.agentDeduction.usd > 0 ||
                      this.data.seller.referred.agentDeduction.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.agentDeduction.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.agentDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.agentDeduction.usd >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.agentDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Abao referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.abao.usd > 0 ||
                  this.data.seller.referred.abao.local > 0
              }"
              *ngIf="
                this.data.seller.referred.abao.usd > 0 ||
                this.data.seller.referred.abao.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Referido a oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.abao.usd > 0 ||
                      this.data.seller.referred.abao.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.abao.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.abao.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.abao.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.abao.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Referido -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.netCommission.usd > 0 ||
                  this.data.seller.referred.netCommission.local > 0
              }"
              *ngIf="
                this.data.seller.referred.netCommission.usd > 0 ||
                this.data.seller.referred.netCommission.local > 0
              "
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.netCommission.usd > 0 ||
                      this.data.seller.referred.netCommission.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.seller.referred.netCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.seller.referred.netCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="this.data.seller.referred.netCommission.local > 0"
                >
                  $
                  {{
                    (this.data.seller.referred.netCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Referido Vendedor END -->

      <!-- Team leader Vendedor -->
      <div
        class="summary show-row"
        *ngIf="
          this.data.seller.teamLeader.name &&
          (this.data.seller.teamLeader.rawCommission.usd > 0 ||
            this.data.seller.teamLeader.rawCommission.local > 0)
        "
      >
        <div
          class="summary-header"
          (click)="this.sellerTeamLeaderBox()"
          [ngClass]="{
            'border-bottom': this.sellerTeamLeaderShow
          }"
        >
          <div class="left-info">
            <div class="icon-arrow-container">
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.sellerTeamLeaderShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Team Leader: {{ this.data.seller.teamLeader.name || "-" }}
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="!this.sellerTeamLeaderShow"
            [ngClass]="{
              end:
                (this.data.seller.teamLeader.netCommission.usd == 0 ||
                  this.data.seller.teamLeader.netCommission.local == 0) &&
                (this.data.seller.usd == 0 || this.data.seller.local == 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.teamLeader.netCommission.usd > 0 &&
                  this.data.seller.usd > 0;
                else sellerteamleaderusdraw
              "
            >
              U$S
              {{
                (this.data.seller.teamLeader.netCommission.usd
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #sellerteamleaderusdraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.seller.teamLeader.rawCommission.usd > 0 &&
                  this.data.seller.usd > 0
                "
              >
                U$S
                {{
                  (this.data.seller.teamLeader.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.teamLeader.netCommission.local > 0 &&
                  this.data.seller.local > 0;
                else sellerteamleaderlocalraw
              "
            >
              $
              {{
                (this.data.seller.teamLeader.netCommission.local
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #sellerteamleaderlocalraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.seller.teamLeader.rawCommission.local > 0 &&
                  this.data.seller.local > 0
                "
              >
                U$S
                {{
                  (this.data.seller.teamLeader.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
          </div>
        </div>
        <div class="full-deductions show" *ngIf="this.sellerTeamLeaderShow">
          <div class="deductions">
            <!-- Comision Bruta Agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.teamLeader.rawCommission.usd > 0 ||
                  this.data.seller.teamLeader.rawCommission.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.seller.teamLeader.rawCommission.usd > 0 ||
                    this.data.seller.teamLeader.rawCommission.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.seller.teamLeader.rawCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.seller.teamLeader.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.seller.teamLeader.rawCommission.local > 0"
                >
                  $
                  {{
                    (this.data.seller.teamLeader.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item': this.data.seller.teamLeader.type.name
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.seller.teamLeader.type.name
                        ]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.seller.teamLeader.type.name == 'TEAM_JUNIOR';
                      else noteamjuniorteamleader
                    "
                  >
                    (T. Leader
                    {{
                      this.dataAgentTypes[
                        this.data.seller.teamLeader.type.name
                      ]
                    }}%)</span
                  >
                  <ng-template #noteamjuniorteamleader>
                    <span *ifNodeShow="[NODE_AR, NODE_GLOBAL]" class="grey-600">
                      ({{ this.data.seller.teamLeader.type.name }}
                      {{
                        this.dataAgentTypes[
                          this.data.seller.teamLeader.type.name
                        ]
                      }}%)</span
                    >
                    <span *ifNodeShow="[NODE_DO]" class="grey-600">
                      (T. Leader
                      {{
                        this.dataAgentTypes[
                          this.data.seller.teamLeader.type.name
                        ]
                      }}%)</span
                    >
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.seller.teamLeader.type.usd > 0 ||
                    this.data.seller.teamLeader.type.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.seller.teamLeader.type.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.seller.teamLeader.type.usd | number: "1.0-2") ||
                      0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.seller.teamLeader.type.local > 0"
                >
                  - $
                  {{
                    (this.data.seller.teamLeader.type.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.teamLeader.agentDeduction.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.seller.teamLeader.agentDeduction.percentage
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.seller.teamLeader.agentDeduction.usd > 0 ||
                    this.data.seller.teamLeader.agentDeduction.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.seller.teamLeader.agentDeduction.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.seller.teamLeader.agentDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.seller.teamLeader.agentDeduction.local > 0"
                >
                  - $
                  {{
                    (this.data.seller.teamLeader.agentDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción ABAO -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.teamLeader.abao.usd > 0 ||
                  this.data.seller.teamLeader.abao.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC T. Leader a oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.seller.teamLeader.abao.usd > 0 ||
                    this.data.seller.teamLeader.abao.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.seller.teamLeader.abao.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.seller.teamLeader.abao.usd | number: "1.0-2") ||
                      0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.seller.teamLeader.abao.local > 0"
                >
                  - $
                  {{
                    (this.data.seller.teamLeader.abao.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Team leader -->
            <div class="deductions-row subtotal show-row-item">
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.seller.teamLeader.rawCommission.usd > 0 ||
                    this.data.seller.teamLeader.rawCommission.local > 0
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.seller.teamLeader.rawCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.seller.teamLeader.netCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="this.data.seller.teamLeader.rawCommission.local > 0"
                >
                  $
                  {{
                    (this.data.seller.teamLeader.netCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Team leader Vendedor END -->

      <!-- Cobrokers Dominicana -->
      <ng-container *ngFor="let cobroker of this.data.cobrokers; let i = index">
        <!-- Cobroker -->
        <div
          class="summary"
          [ngClass]="{ 'show-row': cobroker.name }"
          *ngIf="cobroker.name"
        >
          <div
            class="summary-header"
            (click)="this.toggleCobrokerBox(i)"
            [ngClass]="{
              'border-bottom': this.cobrokerShow[i],
              'height-summary':
                cobroker.officeId != null ||
                cobroker.otherRealEstateName != null
            }"
          >
            <div class="left-info">
              <div
                class="icon-arrow-container"
                *ngIf="
                  cobroker.officeId == null &&
                  cobroker.otherRealEstateName == null
                "
              >
                <div
                  class="arrow-full"
                  [ngClass]="{ rotate: !this.cobrokerShow[i] }"
                ></div>
              </div>
              <div>
                <p class="caption-01-semi-bold grey-800">
                  Cobroker: {{ cobroker.name }}
                </p>
                <p
                  class="caption-01-semi-bold grey-500"
                  *ngIf="cobroker.officeId != null"
                >
                  (RE/MAX {{ cobroker.office }})
                </p>
                <p
                  *ngIf="cobroker.otherRealEstateName != null"
                  class="caption-01-semi-bold grey-500"
                >
                  (Otra inmobiliaria)
                </p>
              </div>
            </div>

            <div
              class="right-info"
              *ngIf="
                !this.cobrokerShow[i] ||
                cobroker.officeId != null ||
                cobroker.otherRealEstateName != null
              "
              [ngClass]="{
                end:
                  cobroker.netCommission.usd == 0 ||
                  cobroker.netCommission.local == 0
              }"
            >
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="cobroker.netCommission.usd > 0"
              >
                U$S
                {{ (cobroker.netCommission.usd | number: "1.0-2") || 0 }}
              </p>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="cobroker.netCommission.local > 0"
              >
                $
                {{ (cobroker.netCommission.local | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>

          <div
            class="full-deductions"
            [ngClass]="{ show: this.cobrokerShow[i] }"
            *ngIf="this.cobrokerShow[i]"
          >
            <div
              class="deductions"
              *ngIf="!cobroker.officeId && !cobroker.otherRealEstateName"
            >
              <!-- Comisión Bruta Cobroker -->
              <div
                class="deductions-row"
                *ngIf="
                  cobroker.rawCommission.usd || cobroker.rawCommission.local
                "
                [ngClass]="{
                  'show-row-item':
                    cobroker.rawCommission.usd || cobroker.rawCommission.local
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">Comisión bruta</p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      !cobroker.rawCommission.usd ||
                      !cobroker.rawCommission.local
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="cobroker.rawCommission.usd"
                  >
                    U$S
                    {{ (cobroker.rawCommission.usd | number: "1.0-2") || 0 }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="cobroker.rawCommission.local"
                  >
                    $
                    {{ (cobroker.rawCommission.local | number: "1.0-2") || 0 }}
                  </p>
                </div>
              </div>

              <!-- Team Leader del Cobroker -->
              <div
                class="deductions-row"
                *ngIf="cobroker.type.usd > 0 || cobroker.type.local > 0"
                [ngClass]="{
                  'show-row-item':
                    cobroker.type.usd > 0 || cobroker.type.local > 0
                }"
              >
                <div class="titles">
                  <p
                    *ifNodeShow="[NODE_DO]"
                    class="paragraph-03-regular grey-700"
                  >
                    <ng-container
                      *ngIf="
                        cobroker.teamLeader.rawCommission.usd > 0 ||
                          cobroker.teamLeader.rawCommission.local > 0;
                        else officeDiscount
                      "
                    >
                      Desc. T. Member ({{
                        this.dataAgentTypes[cobroker.type.name]
                      }}%)
                    </ng-container>

                    <ng-template #officeDiscount>
                      Desc. Oficina
                      <strong>
                        {{ 100 - this.dataAgentTypes[cobroker.type.name] }}%
                      </strong>
                      ({{ cobroker.type.original | capitalize }}
                      {{ this.dataAgentTypes[cobroker.type.name] }}%)
                    </ng-template>
                  </p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end: cobroker.type.usd == 0 || cobroker.type.local == 0
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="cobroker.type.usd && cobroker.type.usd >= 0"
                  >
                    - U$S
                    {{ (cobroker.type.usd | number: "1.0-2") || 0 }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="cobroker.type.local && cobroker.type.local >= 0"
                  >
                    - $
                    {{ (cobroker.type.local | number: "1.0-2") || 0 }}
                  </p>
                </div>
              </div>

              <!-- Comisión Neta Cobroker -->
              <div
                class="deductions-row subtotal"
                [ngClass]="{
                  'show-row-item':
                    cobroker.netCommission.usd > 0 ||
                    cobroker.netCommission.local > 0
                }"
              >
                <div class="titles strong">
                  <p class="caption-01-semi-bold grey-800">Comisión neta</p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      cobroker.netCommission.usd == 0 ||
                      cobroker.netCommission.local == 0
                  }"
                >
                  <p
                    class="caption-01-semi-bold grey-800 align-right"
                    *ngIf="cobroker.netCommission.usd > 0"
                  >
                    U$S
                    {{ cobroker.netCommission.usd | number: "1.0-2" }}
                  </p>
                  <p
                    class="caption-01-semi-bold grey-800"
                    *ngIf="cobroker.netCommission.local > 0"
                  >
                    $
                    {{ cobroker.netCommission.local | number: "1.0-2" }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- ROW -->
        </div>
        <!-- Cobroker Agent END -->

        <!-- Team leader Cobroker -->
        <div
          class="summary show-row"
          *ngIf="
            cobroker.teamLeader.name &&
            (cobroker.teamLeader.rawCommission.usd > 0 ||
              cobroker.teamLeader.rawCommission.local > 0)
          "
        >
          <div
            class="summary-header"
            (click)="this.toggleCobrokerTeamLeader(i)"
            [ngClass]="{
              'border-bottom': this.cobrokerTeamLeaderShow[i]
            }"
          >
            <div class="left-info">
              <div class="icon-arrow-container">
                <div
                  class="arrow-full"
                  [ngClass]="{ rotate: !this.cobrokerTeamLeaderShow[i] }"
                ></div>
              </div>
              <div>
                <p class="caption-01-semi-bold grey-800">
                  T. Leader Cobroker {{ i + 1 }}:
                  {{ cobroker.teamLeader.name || "-" }}
                  <span class="grey-600">({{ cobroker.name || "-" }})</span>
                </p>
              </div>
            </div>

            <div
              class="right-info"
              *ngIf="!this.cobrokerTeamLeaderShow[i]"
              [ngClass]="{
                end:
                  (cobroker.teamLeader.netCommission.usd == 0 ||
                    cobroker.teamLeader.netCommission.local == 0) &&
                  (cobroker.netCommission.usd == 0 ||
                    cobroker.netCommission.local == 0)
              }"
            >
              <!-- USD net / raw -->
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  cobroker.teamLeader.netCommission.usd > 0 &&
                    cobroker.netCommission.usd > 0;
                  else cobrokerTLUsdRaw
                "
              >
                U$S
                {{
                  (cobroker.teamLeader.netCommission.usd | number: "1.0-2") || 0
                }}
              </p>
              <ng-template #cobrokerTLUsdRaw>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    cobroker.teamLeader.rawCommission.usd > 0 &&
                    cobroker.netCommission.usd > 0
                  "
                >
                  U$S
                  {{
                    (cobroker.teamLeader.rawCommission.usd | number: "1.0-2") ||
                      0
                  }}
                </p>
              </ng-template>

              <!-- Local net / raw -->
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  cobroker.teamLeader.netCommission.local > 0 &&
                    cobroker.netCommission.local > 0;
                  else cobrokerTLLocalRaw
                "
              >
                $
                {{
                  (cobroker.teamLeader.netCommission.local | number: "1.0-2") ||
                    0
                }}
              </p>
              <ng-template #cobrokerTLLocalRaw>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    cobroker.teamLeader.rawCommission.local > 0 &&
                    cobroker.netCommission.local > 0
                  "
                >
                  $
                  {{
                    (cobroker.teamLeader.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </ng-template>
            </div>
          </div>

          <div
            class="full-deductions show"
            *ngIf="this.cobrokerTeamLeaderShow[i]"
          >
            <div class="deductions">
              <!-- Comisión bruta TL Cobroker -->
              <div
                class="deductions-row"
                [ngClass]="{
                  'show-row-item':
                    cobroker.teamLeader.rawCommission.usd > 0 ||
                    cobroker.teamLeader.rawCommission.local > 0
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">Comisión bruta</p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      cobroker.teamLeader.rawCommission.usd > 0 ||
                      cobroker.teamLeader.rawCommission.local > 0
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="cobroker.teamLeader.rawCommission.usd > 0"
                  >
                    U$S
                    {{
                      (cobroker.teamLeader.rawCommission.usd
                        | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="cobroker.teamLeader.rawCommission.local > 0"
                  >
                    $
                    {{
                      (cobroker.teamLeader.rawCommission.local
                        | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>

              <!-- Descuento Oficina TL Cobroker -->
              <div
                class="deductions-row"
                [ngClass]="{
                  'show-row-item': cobroker.teamLeader.type.name
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">
                    Desc. Oficina
                    <strong>
                      {{
                        100 -
                          this.dataAgentTypes[cobroker.teamLeader.type.name]
                      }}%
                    </strong>
                    <span
                      class="grey-500"
                      *ngIf="
                        cobroker.teamLeader.type.name == 'TEAM_JUNIOR';
                        else cobrokerTLNoTeamJunior
                      "
                    >
                      (T. Leader
                      {{
                        this.dataAgentTypes[cobroker.teamLeader.type.name]
                      }}%)</span
                    >
                    <ng-template #cobrokerTLNoTeamJunior>
                      <span *ifNodeShow="[NODE_DO]" class="grey-600">
                        (T. Leader
                        {{
                          this.dataAgentTypes[cobroker.teamLeader.type.name]
                        }}%)</span
                      >
                    </ng-template>
                  </p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      cobroker.teamLeader.type.usd > 0 ||
                      cobroker.teamLeader.type.local > 0
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="cobroker.teamLeader.type.usd > 0"
                  >
                    - U$S
                    {{ (cobroker.teamLeader.type.usd | number: "1.0-2") || 0 }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="cobroker.teamLeader.type.local > 0"
                  >
                    - $
                    {{
                      (cobroker.teamLeader.type.local | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>

              <!-- Deducción agente TL Cobroker -->
              <div
                class="deductions-row"
                [ngClass]="{
                  'show-row-item':
                    cobroker.teamLeader.agentDeduction.percentage > 0
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">
                    Deducción agente
                    <strong
                      >{{
                        cobroker.teamLeader.agentDeduction.percentage
                      }}%</strong
                    >
                  </p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      cobroker.teamLeader.agentDeduction.usd > 0 ||
                      cobroker.teamLeader.agentDeduction.local > 0
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="cobroker.teamLeader.agentDeduction.usd > 0"
                  >
                    - U$S
                    {{
                      (cobroker.teamLeader.agentDeduction.usd
                        | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="cobroker.teamLeader.agentDeduction.local > 0"
                  >
                    - $
                    {{
                      (cobroker.teamLeader.agentDeduction.local
                        | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>

              <!-- Comisión Neta TL Cobroker -->
              <div class="deductions-row subtotal show-row-item">
                <div class="titles strong">
                  <p class="caption-01-semi-bold grey-800">Comisión neta</p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      cobroker.teamLeader.netCommission.usd > 0 ||
                      cobroker.teamLeader.netCommission.local > 0
                  }"
                >
                  <p
                    class="caption-01-semi-bold grey-800 align-right"
                    *ngIf="cobroker.teamLeader.netCommission.usd > 0"
                  >
                    U$S
                    {{
                      (cobroker.teamLeader.netCommission.usd
                        | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="caption-01-semi-bold grey-800"
                    *ngIf="cobroker.teamLeader.netCommission.local > 0"
                  >
                    $
                    {{
                      (cobroker.teamLeader.netCommission.local
                        | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- ROW -->
        </div>
        <!-- Team leader Cobroker END -->

        <!-- Cobroker END -->
      </ng-container>
    </div>
    <!-- Punta Vendedora END -->

    <!-- Punta Compradora -->
    <div
      class="row"
      *ngIf="this.data.buyer.percentage > 0"
      [ngClass]="{
        'show-row': this.data.buyer.percentage > 0,
        'border-none': this.data.buyer.percentage > 0
      }"
    >
      <div class="row-header">
        <div class="row-titles">
          <div class="icon-container">
            <qr-icon name="agent" color="primary-700"></qr-icon>
          </div>
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="subheading-01-semi-bold grey-800"
          >
            Punta compradora
            <span class="grey-600"
              >({{ (this.data.buyer.relation | number: "1.0-2") || 0 }}%)</span
            >
          </p>
          <p *ifNodeShow="[NODE_DO]" class="subheading-01-semi-bold grey-800">
            Punta vendedora
            <span class="grey-600"
              >({{ (this.data.buyer.relation | number: "1.0-2") || 0 }}%)</span
            >
          </p>
        </div>
        <div class="row-currencies">
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.buyer.percentage"
          >
            {{ (this.data.buyer.percentage | number: "1.0-2") || 0 }}%
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.buyer.usd"
          >
            U$S {{ (this.data.buyer.usd | number: "1.0-2") || 0 }}
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.buyer.local"
          >
            $ {{ (this.data.buyer.local | number: "1.0-2") || 0 }}
          </p>
        </div>
      </div>

      <!-- Agente Comprador -->
      <div
        class="summary first"
        [ngClass]="{ 'show-row': this.data.buyer.agent.name }"
        *ngIf="this.data.buyer.agent.name"
      >
        <div
          class="summary-header"
          (click)="this.buyerAgentBox()"
          [ngClass]="{
            'border-bottom': this.buyerAgentShow,
            'height-summary':
              this.data.buyer.officeId != null ||
              this.data.buyer.otherRealEstateName != null
          }"
        >
          <div class="left-info">
            <div
              class="icon-arrow-container"
              *ngIf="
                this.data.buyer.officeId == null &&
                this.data.buyer.otherRealEstateName == null
              "
            >
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.buyerAgentShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Agente: {{ this.data.buyer.agent.name }}
              </p>
              <p
                class="caption-01-semi-bold grey-500"
                *ngIf="this.data.buyer.officeId != null"
              >
                (RE/MAX {{ this.data.buyer.agent.office }})
              </p>
              <p
                *ngIf="this.data.buyer.otherRealEstateName != null"
                class="caption-01-semi-bold grey-500"
              >
                ({{ this.data.buyer.otherRealEstateName }})
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="
              !this.buyerAgentShow ||
              this.data.buyer.officeId != null ||
              this.data.buyer.otherRealEstateName != null
            "
            [ngClass]="{
              end:
                this.data.buyer.agent.netCommission.usd == 0 ||
                this.data.buyer.agent.netCommission.local == 0
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="this.data.buyer.agent.netCommission.usd > 0"
            >
              U$S
              {{
                (this.data.buyer.agent.netCommission.usd | number: "1.0-2") || 0
              }}
            </p>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="this.data.buyer.agent.netCommission.local > 0"
            >
              $
              {{
                (this.data.buyer.agent.netCommission.local | number: "1.0-2") ||
                  0
              }}
            </p>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: this.buyerAgentShow }"
          *ngIf="this.buyerAgentShow"
        >
          <div
            class="deductions"
            *ngIf="
              !this.data.buyer.officeId && !this.data.buyer.otherRealEstateName
            "
          >
            <!-- Comision Bruta Agente -->
            <div
              class="deductions-row"
              *ngIf="this.data.buyer.usd || this.data.buyer.local"
              [ngClass]="{
                'show-row-item': this.data.buyer.usd || this.data.buyer.local
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end: !this.data.buyer.usd || !this.data.buyer.local
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.buyer.usd"
                >
                  U$S {{ (this.data.buyer.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.buyer.local"
                >
                  $ {{ (this.data.buyer.local | number: "1.0-2") || 0 }}
                </p>
              </div>
            </div>
            <!-- Deduccion Manual -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.agent.manualDeduction.name &&
                  (this.data.buyer.agent.manualDeduction.usd > 0 ||
                    this.data.buyer.agent.manualDeduction.local > 0)
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción: {{ this.data.buyer.agent.manualDeduction.name }}
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (!this.data.buyer.agent.manualDeduction.usd ||
                      !this.data.buyer.agent.manualDeduction.local) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.agent.manualDeduction.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.agent.manualDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.agent.manualDeduction.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.agent.manualDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Referido -->
            <div
              class="deductions-row"
              *ngIf="
                (this.data.buyer.referred.name ||
                  this.data.buyer.referred.officeId) &&
                this.data.buyer.referred.rawCommission.percentage > 0
              "
              [ngClass]="{
                'show-row-item':
                  (this.data.buyer.referred.name ||
                    this.data.buyer.referred.officeId) &&
                  this.data.buyer.referred.rawCommission.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Referido
                  <span class="grey-500"
                    >({{
                      this.data.buyer.referred.rawCommission.percentage
                        | number: "1.0-2"
                    }}%)</span
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (!this.data.buyer.referred.rawCommission.usd ||
                      !this.data.buyer.referred.rawCommission.local) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.referred.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.referred.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Agente Primer Subtotal -->
            <div
              class="deductions-row subtotal"
              *ngIf="
                this.data.buyer.officeId == null &&
                this.data.buyer.otherRealEstateName == null
              "
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.officeId == null &&
                  this.data.buyer.otherRealEstateName == null
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Subtotal</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.agent.firstSubtotal.usd == 0 ||
                      this.data.buyer.agent.firstSubtotal.local == 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.buyer.agent.firstSubtotal.usd &&
                    this.data.buyer.agent.firstSubtotal.usd >= 0
                  "
                >
                  U$S
                  {{
                    this.data.buyer.agent.firstSubtotal.usd | number: "1.0-2"
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.buyer.agent.firstSubtotal.local &&
                    this.data.buyer.agent.firstSubtotal.local >= 0
                  "
                >
                  $
                  {{
                    this.data.buyer.agent.firstSubtotal.local | number: "1.0-2"
                  }}
                </p>
              </div>
            </div>
            <!-- Team Leader -->
            <div
              class="deductions-row"
              *ngIf="showSplitBuyer"
              [ngClass]="{
                'show-row-item': showSplitBuyer
              }"
            >
              <div class="titles">
                <p
                  *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                  class="paragraph-03-regular grey-700"
                >
                  Team Leader
                </p>

                <p
                  *ifNodeShow="[NODE_DO]"
                  class="paragraph-03-regular grey-700"
                >
                  <ng-container
                    *ngIf="
                      this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                        this.data.buyer.teamLeader.rawCommission.local > 0;
                      else buyerDoOfficeDiscount
                    "
                  >
                    T. Leader
                    ({{
                      100 -
                        this.dataAgentTypes[this.data.buyer.agent.type.name]
                    }}% )
                  </ng-container>
                  <ng-template #buyerDoOfficeDiscount>
                    Desc. Oficina
                    <strong>
                      {{
                        100 -
                          this.dataAgentTypes[this.data.buyer.agent.type.name]
                      }}%
                    </strong>
                    <span
                      class="grey-500"
                      *ngIf="
                        this.data.buyer.agent.type.name === 'TEAM_JUNIOR';
                        else buyerDoOfficeNotTeamJunior
                      "
                    >
                      (T. Member
                      {{
                        this.dataAgentTypes[this.data.buyer.agent.type.name]
                      }}%)</span
                    >
                    <ng-template #buyerDoOfficeNotTeamJunior>
                      <span
                        class="grey-600"
                        *ngIf="
                          this.data.buyer.agent.type.name ==
                            'AGENTE_CIEN_PORCIENTO';
                          else buyerDoOfficeCommonAgent
                        "
                      >
                        (Agente
                        {{
                          this.dataAgentTypes[this.data.buyer.agent.type.name]
                        }}%)</span
                      >
                      <ng-template #buyerDoOfficeCommonAgent>
                        <span class="grey-600">
                          ({{
                            this.data.buyer.agent.type.original | capitalize
                          }}
                          {{
                            this.dataAgentTypes[
                              this.data.buyer.agent.type.name
                            ]
                          }}%)</span
                        >
                      </ng-template>
                    </ng-template>
                  </ng-template>
                </p>
              </div>
              <ng-container
                *ngIf="
                  this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                  this.data.buyer.teamLeader.rawCommission.local > 0
                "
              >
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.buyer.teamLeader.rawCommission.usd == 0 ||
                        this.data.buyer.teamLeader.rawCommission.local == 0) &&
                      (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="
                      this.data.buyer.teamLeader.rawCommission.usd &&
                      this.data.buyer.teamLeader.rawCommission.usd >= 0
                    "
                  >
                    - U$S
                    {{
                      (this.data.buyer.teamLeader.rawCommission.usd
                        | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="
                      this.data.buyer.teamLeader.rawCommission.local &&
                      this.data.buyer.teamLeader.rawCommission.local >= 0
                    "
                  >
                    - $
                    {{
                      (this.data.buyer.teamLeader.rawCommission.local
                        | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </ng-container>

              <ng-container
                *ngIf="
                  this.data.buyer.teamLeader.rawCommission.usd === 0 &&
                  this.data.buyer.teamLeader.rawCommission.local === 0 &&
                  (this.data.buyer.agent.type.usd > 0 ||
                    this.data.buyer.agent.type.local > 0)
                "
              >
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.buyer.agent.type.usd == 0 ||
                        this.data.buyer.agent.type.local == 0) &&
                      (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="this.data.buyer.agent.type.usd > 0"
                  >
                    - U$S
                    {{
                      (this.data.buyer.agent.type.usd | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="this.data.buyer.agent.type.local > 0"
                  >
                    - $
                    {{
                      (this.data.buyer.agent.type.local | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </ng-container>
            </div>
            <!-- Agente Segundo Subtotal -->
            <div
              class="deductions-row subtotal"
              *ngIf="
                (this.NODE !== this.NODE_DO &&
                  (this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                    this.data.buyer.teamLeader.rawCommission.local > 0)) ||
                (this.NODE === this.NODE_DO &&
                  this.data.buyer.agent.deduction.percentage > 0)
              "
              [ngClass]="{
                'show-row-item':
                  data.buyer.teamLeader.rawCommission.usd > 0 ||
                  data.buyer.teamLeader.rawCommission.local > 0,
                'no-border-subtotal':
                  (data.buyer.agent.secondSubtotal.usd > 0 ||
                    data.buyer.agent.secondSubtotal.local > 0) &&
                  (data.buyer.agent.type.usd === 0 ||
                    data.buyer.agent.type.local === 0)
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Subtotal</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.teamLeader.rawCommission.usd == 0 ||
                      this.data.buyer.teamLeader.rawCommission.local == 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.buyer.teamLeader.rawCommission.usd &&
                    this.data.buyer.teamLeader.rawCommission.usd >= 0
                  "
                >
                  U$S
                  {{
                    (this.data.buyer.agent.secondSubtotal.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.buyer.teamLeader.rawCommission.local &&
                    this.data.buyer.teamLeader.rawCommission.local >= 0
                  "
                >
                  $
                  {{
                    (this.data.buyer.agent.secondSubtotal.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <ng-container *ngIf="this.NODE !== this.NODE_DO">
              <div
                class="deductions-row"
                [ngClass]="{
                  'show-row-item':
                    (this.data.buyer.agent.secondSubtotal.usd > 0 ||
                      this.data.buyer.agent.secondSubtotal.local > 0) &&
                    (this.data.buyer.agent.type.usd > 0 ||
                      this.data.buyer.agent.type.local > 0)
                }"
              >
                <div class="titles">
                  <p class="paragraph-03-regular grey-700">
                    Desc. Oficina
                    <strong>
                      {{
                        100 -
                          this.dataAgentTypes[this.data.buyer.agent.type.name]
                      }}%
                    </strong>
                    <span
                      class="grey-500"
                      *ngIf="
                        this.data.buyer.agent.type.name == 'TEAM_JUNIOR';
                        else noteamjunior
                      "
                    >
                      (T. Member
                      {{
                        this.dataAgentTypes[this.data.buyer.agent.type.name]
                      }}%)</span
                    >
                    <ng-template #noteamjunior>
                      <span
                        class="grey-600"
                        *ngIf="
                          this.data.buyer.agent.type.name ==
                            'AGENTE_CIEN_PORCIENTO';
                          else buyercommonagent
                        "
                      >
                        (Agente
                        {{
                          this.dataAgentTypes[this.data.buyer.agent.type.name]
                        }}%)</span
                      >
                      <ng-template #buyercommonagent>
                        <span
                          *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                          class="grey-600"
                        >
                          ({{ this.data.buyer.agent.type.name }}
                          {{
                            this.dataAgentTypes[
                              this.data.buyer.agent.type.name
                            ]
                          }}%)</span
                        >
                      </ng-template>
                    </ng-template>
                  </p>
                </div>
                <div
                  class="comissions"
                  [ngClass]="{
                    end:
                      (this.data.buyer.agent.secondSubtotal.usd == 0 ||
                        this.data.buyer.agent.secondSubtotal.local == 0) &&
                      (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                  }"
                >
                  <p
                    class="paragraph-03-regular grey-700 align-right"
                    *ngIf="
                      this.data.buyer.agent.secondSubtotal.usd >= 0 &&
                      this.data.buyer.usd > 0
                    "
                  >
                    - U$S
                    {{
                      (this.data.buyer.agent.type.usd | number: "1.0-2") || 0
                    }}
                  </p>
                  <p
                    class="paragraph-03-regular grey-700"
                    *ngIf="
                      this.data.buyer.agent.secondSubtotal.local >= 0 &&
                      this.data.buyer.local > 0
                    "
                  >
                    - $
                    {{
                      (this.data.buyer.agent.type.local | number: "1.0-2") || 0
                    }}
                  </p>
                </div>
              </div>
            </ng-container>
            <!-- Deduccion agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.agent.deduction &&
                  this.data.buyer.agent.deduction.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.buyer.agent.deduction.percentage
                        | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.agent.deduction.usd > 0 ||
                      this.data.buyer.agent.deduction.local > 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.agent.deduction.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.agent.deduction.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.agent.deduction.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.agent.deduction.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- ABAO Vendedora -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.agent.abao.usd > 0 ||
                  this.data.buyer.agent.abao.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Agente a Oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.agent.abao.usd > 0 ||
                      this.data.buyer.agent.abao.local > 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.agent.abao.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{ (this.data.buyer.agent.abao.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.agent.abao.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.agent.abao.local | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Agente -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.agent.netCommission.usd > 0 ||
                  this.data.buyer.agent.netCommission.local > 0
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.usd || this.data.buyer.local) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.buyer.usd >= 0 && this.data.buyer.usd > 0"
                >
                  U$S
                  {{
                    this.data.buyer.agent.netCommission.usd | number: "1.0-2"
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.buyer.local >= 0 && this.data.buyer.local > 0
                  "
                >
                  $
                  {{
                    this.data.buyer.agent.netCommission.local | number: "1.0-2"
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>

    <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Agente Comprador END -->

      <!-- Referido Comprador -->
      <div
        class="summary"
        *ngIf="
          ((this.data.buyer.referred.name &&
            this.data.buyer.referred.rawCommission.percentage) ||
            this.data.buyer.referred.officeId) &&
          this.data.buyer.agent.office
        "
        [ngClass]="{
          'show-row':
            (this.data.buyer.referred.name ||
              this.data.buyer.referred.officeId) &&
            this.data.buyer.agent.office
        }"
      >
        <div
          class="summary-header"
          (click)="this.buyerReferredBox()"
          [ngClass]="{
            'border-bottom': this.buyerReferredShow,
            'height-summary': this.data.buyer.referred.officeId
          }"
        >
          <div class="left-info">
            <div
              class="icon-arrow-container"
              *ngIf="!this.data.buyer.referred.officeId"
            >
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.buyerReferredShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Referido: {{ this.data.buyer.referred.name || "-" }}
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.buyer.referred.officeId &&
                  this.data.buyer.referred.officeId !=
                    this.data.buyer.referred.name &&
                  this.data.buyer.referred.officeId != '(Otra inmobiliaria)'
                "
              >
                (RE/MAX {{ this.data.buyer.referred.officeId }})
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.buyer.referred.officeId &&
                  (this.data.buyer.referred.officeId ==
                    this.data.buyer.referred.name ||
                    this.data.buyer.referred.officeId == '(Otra inmobiliaria)')
                "
              >
                (Otra Inmobiliaria)
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="
              !this.buyerReferredShow ||
              (this.data.buyer.referred.officeId &&
                this.data.buyer.agent.office)
            "
            [ngClass]="{
              end:
                (this.data.buyer.referred.netCommission.usd == 0 ||
                  this.data.buyer.referred.netCommission.local == 0) &&
                (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.buyer.referred.netCommission.usd > 0 &&
                  this.data.buyer.usd > 0;
                else buyerreferredusdraw
              "
            >
              U$S
              {{
                (this.data.buyer.referred.netCommission.usd
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #buyerreferredusdraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.buyer.referred.rawCommission.usd > 0 &&
                  this.data.buyer.usd > 0
                "
              >
                U$S
                {{
                  (this.data.buyer.referred.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.buyer.referred.netCommission.local > 0 &&
                  this.data.buyer.local > 0;
                else buyerreferredlocalraw
              "
            >
              $
              {{
                (this.data.buyer.referred.netCommission.local
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #buyerreferredlocalraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.buyer.referred.rawCommission.local > 0 &&
                  this.data.buyer.local > 0
                "
              >
                U$S
                {{
                  (this.data.buyer.referred.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: !this.data.buyer.referred.officeId }"
          *ngIf="!this.data.buyer.referred.officeId && this.buyerReferredShow"
        >
          <div class="deductions">
            <!-- Comision Bruta Referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.referred.rawCommission.usd > 0 ||
                  this.data.buyer.referred.rawCommission.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.referred.rawCommission.usd == 0 ||
                      this.data.buyer.referred.rawCommission.local == 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  U$S
                  {{
                    (this.data.buyer.referred.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  $
                  {{
                    (this.data.buyer.referred.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.referred.rawCommission.usd > 0 ||
                  this.data.buyer.referred.rawCommission.local > 0
              }"
              *ngIf="
                this.data.buyer.referred.rawCommission.usd > 0 ||
                this.data.buyer.referred.rawCommission.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.buyer.referred.type.name === ""
                            ? this.data.buyer.referred.type.original
                            : this.data.buyer.referred.type.name
                        ]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.buyer.referred.type.name == 'TEAM_JUNIOR';
                      else noteamjuniorreferred
                    "
                  >
                    (T. Member
                    {{
                      this.dataAgentTypes[this.data.buyer.referred.type.name]
                    }}%)</span
                  >
                  <ng-template #noteamjuniorreferred>
                    <span
                      class="grey-600"
                      *ngIf="
                        this.data.buyer.referred.type.name ==
                          'AGENTE_CIEN_PORCIENTO';
                        else commonagentbuyerreferred
                      "
                    >
                      (Agente
                      {{
                        this.dataAgentTypes[this.data.buyer.referred.type.name]
                      }}%)</span
                    >

                    <ng-template #commonagentbuyerreferred>
                      <span
                        *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                        class="grey-600"
                      >
                        ({{ this.data.buyer.referred.type.name }}
                        {{
                          this.dataAgentTypes[
                            this.data.buyer.referred.type.name
                          ]
                        }}%)</span
                      >
                      <span *ifNodeShow="[NODE_DO]" class="grey-600">
                        ({{
                          this.data.buyer.referred.type.original | capitalize
                        }}
                        {{
                          this.dataAgentTypes[
                            this.data.buyer.referred.type.name
                          ]
                        }}%)</span
                      >
                    </ng-template>
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.referred.rawCommission.usd == 0 ||
                      this.data.buyer.referred.rawCommission.local == 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.referred.type.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.referred.rawCommission.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.referred.type.local | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.referred.agentDeduction.usd > 0 ||
                  this.data.buyer.referred.agentDeduction.local > 0
              }"
              *ngIf="this.data.buyer.referred.agentDeduction.percentage > 0"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.buyer.referred.agentDeduction.percentage
                        | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.referred.agentDeduction.usd > 0 ||
                      this.data.buyer.referred.agentDeduction.local > 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.referred.agentDeduction.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.referred.agentDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.referred.agentDeduction.usd >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.referred.agentDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Abao referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.referred.abao.usd > 0 ||
                  this.data.buyer.referred.abao.local > 0
              }"
              *ngIf="
                this.data.buyer.referred.abao.usd > 0 ||
                this.data.buyer.referred.abao.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Referido a oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.referred.abao.usd > 0 ||
                      this.data.buyer.referred.abao.local > 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.buyer.referred.abao.usd >= 0 &&
                    this.data.buyer.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.buyer.referred.abao.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.buyer.referred.abao.local >= 0 &&
                    this.data.buyer.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.buyer.referred.abao.local | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Referido -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.referred.netCommission.usd > 0 ||
                  this.data.buyer.referred.netCommission.local > 0
              }"
              *ngIf="
                this.data.buyer.referred.netCommission.usd > 0 ||
                this.data.buyer.referred.netCommission.local > 0
              "
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.buyer.referred.netCommission.usd > 0 ||
                      this.data.buyer.referred.netCommission.local > 0) &&
                    (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.buyer.referred.netCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.buyer.referred.netCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="this.data.buyer.referred.netCommission.local > 0"
                >
                  $
                  {{
                    (this.data.buyer.referred.netCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Referido Comprador END -->

      <!-- Team leader Comprador -->
      <div
        class="summary show-row"
        *ngIf="
          this.data.buyer.teamLeader.name &&
          (this.data.buyer.teamLeader.rawCommission.usd > 0 ||
            this.data.buyer.teamLeader.rawCommission.local > 0)
        "
      >
        <div
          class="summary-header"
          (click)="this.buyerTeamLeaderBox()"
          [ngClass]="{
            'border-bottom': this.buyerTeamLeaderShow
          }"
        >
          <div class="left-info">
            <div class="icon-arrow-container">
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.buyerTeamLeaderShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Team Leader: {{ this.data.buyer.teamLeader.name || "-" }}
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="!this.buyerTeamLeaderShow"
            [ngClass]="{
              end:
                (this.data.buyer.teamLeader.netCommission.usd == 0 ||
                  this.data.buyer.teamLeader.netCommission.local == 0) &&
                (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.buyer.teamLeader.netCommission.usd > 0 &&
                  this.data.buyer.usd > 0;
                else buyerteamleaderusdraw
              "
            >
              U$S
              {{
                (this.data.buyer.teamLeader.netCommission.usd
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #buyerteamleaderusdraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.buyer.teamLeader.rawCommission.usd > 0 &&
                  this.data.buyer.usd > 0
                "
              >
                U$S
                {{
                  (this.data.buyer.teamLeader.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.buyer.teamLeader.netCommission.local > 0 &&
                  this.data.buyer.local > 0;
                else buyerteamleaderlocalraw
              "
            >
              $
              {{
                (this.data.buyer.teamLeader.netCommission.local
                  | number: "1.0-2") || 0
              }}
            </p>
            <ng-template #buyerteamleaderlocalraw>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.buyer.teamLeader.rawCommission.local > 0 &&
                  this.data.buyer.local > 0
                "
              >
                U$S
                {{
                  (this.data.buyer.teamLeader.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </ng-template>
          </div>
        </div>
        <div class="full-deductions show" *ngIf="this.buyerTeamLeaderShow">
          <div class="deductions">
            <!-- Comision Bruta Agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                  this.data.buyer.teamLeader.rawCommission.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                    this.data.buyer.teamLeader.rawCommission.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.buyer.teamLeader.rawCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.buyer.teamLeader.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.buyer.teamLeader.rawCommission.local > 0"
                >
                  $
                  {{
                    (this.data.buyer.teamLeader.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item': this.data.buyer.teamLeader.type.name
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.buyer.teamLeader.type.name
                        ]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.buyer.teamLeader.type.name == 'TEAM_JUNIOR';
                      else noteamjuniorteamleader
                    "
                  >
                    (T. Leader
                    {{
                      this.dataAgentTypes[this.data.buyer.teamLeader.type.name]
                    }}%)</span
                  >
                  <ng-template #noteamjuniorteamleader>
                    <span *ifNodeShow="[NODE_AR, NODE_GLOBAL]" class="grey-600">
                      ({{ this.data.buyer.teamLeader.type.name }}
                      {{
                        this.dataAgentTypes[
                          this.data.buyer.teamLeader.type.name
                        ]
                      }}%)</span
                    >
                    <span *ifNodeShow="[NODE_DO]" class="grey-600">
                      (T. Leader
                      {{
                        this.dataAgentTypes[
                          this.data.buyer.teamLeader.type.name
                        ]
                      }}%)</span
                    >
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.buyer.teamLeader.type.usd > 0 ||
                    this.data.buyer.teamLeader.type.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.buyer.teamLeader.type.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.buyer.teamLeader.type.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.buyer.teamLeader.type.local > 0"
                >
                  - $
                  {{
                    (this.data.buyer.teamLeader.type.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.teamLeader.agentDeduction.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.buyer.teamLeader.agentDeduction.percentage
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.buyer.teamLeader.agentDeduction.usd > 0 ||
                    this.data.buyer.teamLeader.agentDeduction.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.buyer.teamLeader.agentDeduction.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.buyer.teamLeader.agentDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.buyer.teamLeader.agentDeduction.local > 0"
                >
                  - $
                  {{
                    (this.data.buyer.teamLeader.agentDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción ABAO -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.buyer.teamLeader.abao.usd > 0 ||
                  this.data.buyer.teamLeader.abao.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC T. Leader a oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.buyer.teamLeader.abao.usd > 0 ||
                    this.data.buyer.teamLeader.abao.local > 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.buyer.teamLeader.abao.usd > 0"
                >
                  - U$S
                  {{
                    (this.data.buyer.teamLeader.abao.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.buyer.teamLeader.abao.local > 0"
                >
                  - $
                  {{
                    (this.data.buyer.teamLeader.abao.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Team leader -->
            <div class="deductions-row subtotal show-row-item">
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.buyer.teamLeader.rawCommission.usd > 0 ||
                    this.data.buyer.teamLeader.rawCommission.local > 0
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.buyer.teamLeader.rawCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.buyer.teamLeader.netCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="this.data.buyer.teamLeader.rawCommission.local > 0"
                >
                  $
                  {{
                    (this.data.buyer.teamLeader.netCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Team leader Comprador END -->
    </div>
    <!-- Punta Comprador END -->
  </ng-container>

  <!-- REFERIDO A COBRAR -->
  <ng-container *ngIf="this.data.referred.isReferred">
    <div
      class="row show-row border-none"
      *ngIf="this.data.closedPrice.usd > 0 || this.data.closedPrice.local > 0"
    >
      <div class="row-header">
        <div class="row-titles">
          <div class="icon-container">
            <qr-icon name="agent" color="primary-700"></qr-icon>
          </div>
          <p class="subheading-01-semi-bold grey-800">Referido</p>
        </div>
        <div class="row-currencies">
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.closedPrice.usd > 0"
          >
            U$S {{ (this.data.closedPrice.usd | number: "1.0-2") || 0 }}
          </p>
          <p
            class="subheading-01-semi-bold grey-800"
            *ngIf="this.data.closedPrice.local > 0"
          >
            $ {{ (this.data.closedPrice.local | number: "1.0-2") || 0 }}
          </p>
        </div>
      </div>

      <!-- Agente Vendedor -->
      <div
        class="summary first"
        [ngClass]="{ 'show-row': this.data.referred.name }"
        *ngIf="this.data.referred.name"
      >
        <div
          class="summary-header"
          (click)="this.referidoACobrarBox()"
          [ngClass]="{
            'border-bottom': this.referidoACobrarShow
          }"
        >
          <div class="left-info">
            <div class="icon-arrow-container">
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.referidoACobrarShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Agente: {{ this.data.referred.name }}
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="!this.referidoACobrarShow"
            [ngClass]="{
              end:
                this.data.referred.netCommission.usd == 0 ||
                this.data.referred.netCommission.local == 0
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="this.data.referred.netCommission.usd > 0"
            >
              U$S
              {{
                (this.data.referred.netCommission.usd | number: "1.0-2") || 0
              }}
            </p>
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="this.data.referred.netCommission.local > 0"
            >
              $
              {{
                (this.data.referred.netCommission.local | number: "1.0-2") || 0
              }}
            </p>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: this.referidoACobrarShow }"
          *ngIf="this.referidoACobrarShow"
        >
          <div class="deductions">
            <!-- Comision Bruta Agente -->
            <div
              class="deductions-row"
              *ngIf="
                this.data.closedPrice.usd > 0 || this.data.closedPrice.local > 0
              "
              [ngClass]="{
                'show-row-item':
                  this.data.closedPrice.usd > 0 ||
                  this.data.closedPrice.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.closedPrice.usd == 0 ||
                    this.data.closedPrice.local == 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.closedPrice.usd > 0"
                >
                  U$S {{ (this.data.closedPrice.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.closedPrice.local > 0"
                >
                  $ {{ (this.data.closedPrice.local | number: "1.0-2") || 0 }}
                </p>
              </div>
            </div>
            <!-- Deduccion Manual -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.referred.manualDeduction.name &&
                  (this.data.referred.manualDeduction.usd > 0 ||
                    this.data.referred.manualDeduction.local > 0)
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción: {{ this.data.referred.manualDeduction.name }}
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (!this.data.referred.manualDeduction.usd ||
                      !this.data.referred.manualDeduction.local) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.referred.manualDeduction.usd >= 0 &&
                    this.data.closedPrice.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.referred.manualDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.referred.manualDeduction.local >= 0 &&
                    this.data.closedPrice.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.referred.manualDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Agente Primer Subtotal -->
            <div class="deductions-row subtotal show-row-item">
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Subtotal</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.referred.firstSubtotal.usd == 0 ||
                      this.data.referred.firstSubtotal.local == 0) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.referred.firstSubtotal.usd &&
                    this.data.referred.firstSubtotal.usd >= 0
                  "
                >
                  U$S
                  {{ this.data.referred.firstSubtotal.usd | number: "1.0-2" }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.referred.firstSubtotal.local &&
                    this.data.referred.firstSubtotal.local >= 0
                  "
                >
                  $
                  {{ this.data.referred.firstSubtotal.local | number: "1.0-2" }}
                </p>
              </div>
            </div>
            <!-- Team Leader -->
            <!-- <div class="deductions-row">
            <div class="titles">
              <p class="paragraph-03-regular grey-700">Team leader</p>
            </div>
            <div class="comissions">
              <p class="paragraph-03-regular grey-700 align-right">
                - U$S
                {{
                  (this.data.seller.teamLeader?.rawCommission?.usd
                    | number : "1.0-2") || 0
                }}
              </p>
              <p class="paragraph-03-regular grey-700">
                - $
                {{
                  (this.data.seller.teamLeader?.rawCommission?.local
                    | number : "1.0-2") || 0
                }}
              </p>
            </div>
          </div> -->
            <!-- Agente Segundo Subtotal -->
            <!-- <div class="deductions-row subtotal">
            <div class="titles strong">
              <p class="caption-01-semi-bold grey-800">Subtotal</p>
            </div>
            <div class="comissions">
              <p class="caption-01-semi-bold grey-800 align-right">U$S 1.775</p>
              <p class="caption-01-semi-bold grey-800">$ 0</p>
            </div>
          </div> -->
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.referred.type.usd > 0 ||
                  this.data.referred.type.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 - this.dataAgentTypes[this.data.referred.type.name]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.referred.type.name == 'TEAM_JUNIOR';
                      else noteamjunior
                    "
                  >
                    (T. Member
                    {{
                      this.dataAgentTypes[this.data.referred.type.name]
                    }}%)</span
                  >
                  <ng-template #noteamjunior>
                    <span *ifNodeShow="[NODE_AR, NODE_GLOBAL]" class="grey-600">
                      ({{ this.data.referred.type.name }}
                      {{
                        this.dataAgentTypes[this.data.referred.type.name]
                      }}%)</span
                    >
                    <span *ifNodeShow="[NODE_DO]" class="grey-600">
                      ({{ this.data.referred.type.original | capitalize }}
                      {{
                        this.dataAgentTypes[this.data.referred.type.name]
                      }}%)</span
                    >
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.referred.type.usd == 0 ||
                      this.data.referred.type.local == 0) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.referred.type.usd >= 0 &&
                    this.data.closedPrice.usd > 0
                  "
                >
                  - U$S
                  {{ (this.data.referred.type.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.referred.type.local >= 0 &&
                    this.data.closedPrice.local > 0
                  "
                >
                  - $
                  {{ (this.data.referred.type.local | number: "1.0-2") || 0 }}
                </p>
              </div>
            </div>
            <!-- Deduccion agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.referred.deduction &&
                  this.data.referred.deduction.percentage > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.referred.deduction.percentage | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.referred.deduction.usd > 0 ||
                      this.data.referred.deduction.local > 0) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.referred.deduction.usd >= 0 &&
                    this.data.closedPrice.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.referred.deduction.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.referred.deduction.local >= 0 &&
                    this.data.closedPrice.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.referred.deduction.local | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- ABAO Vendedora -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.referred.abao.usd > 0 ||
                  this.data.referred.abao.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Agente a Oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.referred.abao.usd > 0 ||
                      this.data.referred.abao.local > 0) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.referred.abao.usd >= 0 &&
                    this.data.closedPrice.usd > 0
                  "
                >
                  - U$S
                  {{ (this.data.referred.abao.usd | number: "1.0-2") || 0 }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.referred.abao.local >= 0 &&
                    this.data.closedPrice.local > 0
                  "
                >
                  - $
                  {{ (this.data.referred.abao.local | number: "1.0-2") || 0 }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Agente -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.referred.netCommission.usd > 0 ||
                  this.data.referred.netCommission.local > 0
              }"
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.closedPrice.usd ||
                      this.data.closedPrice.local) &&
                    (this.data.closedPrice.usd == 0 ||
                      this.data.closedPrice.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="
                    this.data.closedPrice.usd >= 0 &&
                    this.data.closedPrice.usd > 0
                  "
                >
                  U$S
                  {{ this.data.referred.netCommission.usd | number: "1.0-2" }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="
                    this.data.closedPrice.local >= 0 &&
                    this.data.closedPrice.local > 0
                  "
                >
                  $
                  {{ this.data.referred.netCommission.local | number: "1.0-2" }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>

    <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Agente Vendedor END -->

      <!-- Referido Vendedor -->
      <div
        class="summary"
        *ngIf="
          ((this.data.seller.referred.name &&
            this.data.seller.referred.rawCommission.percentage) ||
            this.data.seller.referred.officeId) &&
          this.data.seller.agent.office
        "
        [ngClass]="{
          'show-row':
            (this.data.seller.referred.name ||
              this.data.seller.referred.officeId) &&
            this.data.seller.agent.office
        }"
      >
        <div
          class="summary-header"
          (click)="this.sellerReferredBox()"
          [ngClass]="{
            'border-bottom': this.sellerReferredShow,
            'height-summary': this.data.seller.referred.officeId
          }"
        >
          <div class="left-info">
            <div
              class="icon-arrow-container"
              *ngIf="!this.data.seller.referred.officeId"
            >
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.sellerReferredShow }"
              ></div>
            </div>
            <div>
              <p class="caption-01-semi-bold grey-800">
                Referido: {{ this.data.seller.referred.name || "-" }}
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.seller.referred.officeId &&
                  this.data.seller.referred.officeId !=
                    this.data.seller.referred.name &&
                  this.data.seller.referred.officeId != '(Otra inmobiliaria)'
                "
              >
                (RE/MAX {{ this.data.seller.referred.officeId }})
              </p>
              <p
                class="caption-02-semi-bold grey-500"
                *ngIf="
                  this.data.seller.referred.officeId &&
                  (this.data.seller.referred.officeId ==
                    this.data.seller.referred.name ||
                    this.data.seller.referred.officeId == '(Otra inmobiliaria)')
                "
              >
                (Otra Inmobiliaria)
              </p>
            </div>
          </div>
          <div
            class="right-info"
            *ngIf="
              !this.sellerReferredShow ||
              (this.data.seller.referred.officeId &&
                this.data.seller.agent.office)
            "
            [ngClass]="{
              end:
                (this.data.seller.referred.netCommission.usd == 0 ||
                  this.data.seller.referred.netCommission.local == 0) &&
                (this.data.seller.usd == 0 || this.data.seller.local == 0)
            }"
          >
            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.referred.netCommission.usd >= 0 &&
                this.data.seller.usd > 0
              "
            >
              U$S
              {{
                (this.data.seller.referred.netCommission.usd
                  | number: "1.0-2") || 0
              }}
            </p>

            <p
              class="caption-01-semi-bold grey-800"
              *ngIf="
                this.data.seller.referred.netCommission.local >= 0 &&
                this.data.seller.local > 0
              "
            >
              $
              {{
                (this.data.seller.referred.netCommission.local
                  | number: "1.0-2") || 0
              }}
            </p>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: !this.data.seller.referred.officeId }"
          *ngIf="!this.data.seller.referred.officeId && this.sellerReferredShow"
        >
          <div class="deductions">
            <!-- Comision Bruta Referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.rawCommission.usd > 0 ||
                  this.data.seller.referred.rawCommission.local > 0
              }"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.rawCommission.usd == 0 ||
                      this.data.seller.referred.rawCommission.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.rawCommission.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  U$S
                  {{
                    (this.data.seller.referred.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.rawCommission.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  $
                  {{
                    (this.data.seller.referred.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.type.usd > 0 ||
                  this.data.seller.referred.type.local > 0
              }"
              *ngIf="
                this.data.seller.referred.type.usd > 0 ||
                this.data.seller.referred.type.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.seller.referred.type.name
                        ]
                    }}%
                  </strong>
                  <span
                    class="grey-500"
                    *ngIf="
                      this.data.seller.referred.type.name == 'TEAM_JUNIOR';
                      else noteamjuniorreferred
                    "
                  >
                    (T. Member
                    {{
                      this.dataAgentTypes[this.data.seller.referred.type.name]
                    }}%)</span
                  >
                  <ng-template #noteamjuniorreferred>
                    <span *ifNodeShow="[NODE_AR, NODE_GLOBAL]" class="grey-600">
                      ({{ this.data.seller.referred.type.name }}
                      {{
                        this.dataAgentTypes[
                          this.data.seller.referred.type.name
                        ]
                      }}%)</span
                    >
                    <span *ifNodeShow="[NODE_DO]" class="grey-600">
                      ({{
                        this.data.seller.referred.type.original | capitalize
                      }}
                      {{
                        this.dataAgentTypes[
                          this.data.seller.referred.type.name
                        ]
                      }}%)</span
                    >
                  </ng-template>
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.type.usd == 0 ||
                      this.data.seller.referred.type.local == 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.type.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.type.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.type.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.type.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.agentDeduction.usd > 0 ||
                  this.data.seller.referred.agentDeduction.local > 0
              }"
              *ngIf="this.data.seller.referred.agentDeduction.percentage > 0"
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.seller.referred.agentDeduction.percentage
                        | number: "1.0-2"
                    }}%</strong
                  >
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.agentDeduction.usd > 0 ||
                      this.data.seller.referred.agentDeduction.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.agentDeduction.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.agentDeduction.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.agentDeduction.usd >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.agentDeduction.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Abao referido -->
            <div
              class="deductions-row"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.abao.usd > 0 ||
                  this.data.seller.referred.abao.local > 0
              }"
              *ngIf="
                this.data.seller.referred.abao.usd > 0 ||
                this.data.seller.referred.abao.local > 0
              "
            >
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  ABAO FC Referido a oficina
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.abao.usd > 0 ||
                      this.data.seller.referred.abao.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="
                    this.data.seller.referred.abao.usd >= 0 &&
                    this.data.seller.usd > 0
                  "
                >
                  - U$S
                  {{
                    (this.data.seller.referred.abao.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="
                    this.data.seller.referred.abao.local >= 0 &&
                    this.data.seller.local > 0
                  "
                >
                  - $
                  {{
                    (this.data.seller.referred.abao.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Referido -->
            <div
              class="deductions-row subtotal"
              [ngClass]="{
                'show-row-item':
                  this.data.seller.referred.netCommission.usd > 0 ||
                  this.data.seller.referred.netCommission.local > 0
              }"
              *ngIf="
                this.data.seller.referred.netCommission.usd > 0 ||
                this.data.seller.referred.netCommission.local > 0
              "
            >
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    (this.data.seller.referred.netCommission.usd > 0 ||
                      this.data.seller.referred.netCommission.local > 0) &&
                    (this.data.seller.usd == 0 || this.data.seller.local == 0)
                }"
              >
                <p
                  class="caption-01-semi-bold grey-800 align-right"
                  *ngIf="this.data.seller.referred.netCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.seller.referred.netCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="caption-01-semi-bold grey-800"
                  *ngIf="this.data.seller.referred.netCommission.local > 0"
                >
                  $
                  {{
                    (this.data.seller.referred.netCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Referido Vendedor END -->

      <!-- Team leader Vendedor -->
      <div
        class="summary"
        *ngIf="this.data.seller.teamLeader && this.data.seller.teamLeader.name"
      >
        <div
          class="summary-header"
          (click)="this.sellerTeamLeaderShow = !this.sellerTeamLeaderShow"
          [ngClass]="{ 'border-bottom': this.sellerTeamLeaderShow }"
        >
          <div class="left-info">
            <div class="icon-arrow-container">
              <div
                class="arrow-full"
                [ngClass]="{ rotate: !this.sellerAgentShow }"
              ></div>
            </div>
            <p class="caption-01-semi-bold grey-800">
              Team leader: {{ this.data.seller.teamLeader?.name }}
            </p>
          </div>
          <div class="right-info" *ngIf="!this.sellerTeamLeaderShow">
            <p class="caption-01-semi-bold grey-800">U$S</p>
            <p class="caption-01-semi-bold grey-800"></p>
          </div>
        </div>
        <div
          class="full-deductions"
          [ngClass]="{ show: this.sellerTeamLeaderShow }"
          *ngIf="this.sellerTeamLeaderShow"
        >
          <div class="deductions">
            <!-- Comision Bruta Agente -->
            <div class="deductions-row">
              <div class="titles">
                <p class="paragraph-03-regular grey-700">Comisión bruta</p>
              </div>
              <div class="comissions">
                <p class="paragraph-03-regular grey-700 align-right">
                  U$S
                  {{
                    (this.data.seller.teamLeader?.rawCommission?.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p class="paragraph-03-regular grey-700">
                  $
                  {{
                    (this.data.seller.teamLeader?.rawCommission?.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Descuento Oficina -->
            <div class="deductions-row" *ngIf="this.data.seller.teamLeader">
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Desc. Oficina
                  <strong>
                    {{
                      100 -
                        this.dataAgentTypes[
                          this.data.seller.teamLeader.type.name
                        ]
                    }}%
                  </strong>
                  <span *ifNodeShow="[NODE_AR, NODE_GLOBAL]" class="grey-500">
                    ({{ this.data.seller.teamLeader.type.name }}
                    {{
                      this.dataAgentTypes[
                        this.data.seller.teamLeader.type.name
                      ]
                    }}%)</span
                  >
                  <span *ifNodeShow="[NODE_DO]" class="grey-500">
                    (T. Leader
                    {{
                      this.dataAgentTypes[
                        this.data.seller.teamLeader.type.name
                      ]
                    }}%)</span
                  >
                </p>
              </div>
              <div class="comissions">
                <p class="paragraph-03-regular grey-700 align-right">
                  - U$S
                  {{
                    (this.data.seller.teamLeader.type.usd | number: "1.0-2") ||
                      0
                  }}
                </p>
                <p class="paragraph-03-regular grey-700">
                  - $
                  {{
                    (this.data.seller.teamLeader.type.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Deducción agente -->
            <div class="deductions-row">
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Deducción agente
                  <strong
                    >{{
                      this.data.seller.teamLeader.agentDeduction.percentage
                    }}%</strong
                  >
                </p>
              </div>
              <div class="comissions">
                <p class="paragraph-03-regular grey-700 align-right">
                  - U$S
                  {{
                    (this.data.seller.teamLeader.rawCommission.usd
                      | number: "1.0-2") || 0
                  }}
                </p>
                <p class="paragraph-03-regular grey-700">
                  - $
                  {{
                    (this.data.seller.teamLeader.rawCommission.local
                      | number: "1.0-2") || 0
                  }}
                </p>
              </div>
            </div>
            <!-- Comision Neta Team leader -->
            <div class="deductions-row subtotal">
              <div class="titles strong">
                <p class="caption-01-semi-bold grey-800">Comisión neta</p>
              </div>
              <div class="comissions">
                <p class="caption-01-semi-bold grey-800 align-right">
                  U$S 1.775
                </p>
                <p class="caption-01-semi-bold grey-800">$ 0</p>
              </div>
            </div>
          </div>

          <!-- <div class="referred-container summary"></div>
    
        <div class="teamleader-container summary"></div> -->
        </div>
        <!-- ROW -->
      </div>
      <!-- Team leader Vendedor END -->
    </div>
  </ng-container>
  <!-- REFERIDO A COBRAR end -->

  <!-- OFICINA -->
  <div
    class="row last"
    *ngIf="
      this.data.office.rawCommission.percentage > 0 &&
      (this.data.seller.agent.name ||
        this.data.buyer.agent.name ||
        this.data.referred.name)
    "
    [ngClass]="{
      'show-row': this.data.office.rawCommission.percentage > 0,
      'border-none': this.data.office.rawCommission.percentage > 0
    }"
  >
    <div
      class="row-header"
      *ngIf="this.data.office.rawCommission.percentage > 0"
    >
      <div class="row-titles">
        <div class="icon-container">
          <qr-icon name="real-estate" color="primary-700"></qr-icon>
        </div>
        <p class="subheading-01-semi-bold grey-800">Oficina</p>
      </div>
      <div class="row-currencies">
        <p class="subheading-01-semi-bold grey-800">
          {{
            (this.data.office.rawCommission.percentage | number: "1.0-2") || 0
          }}%
        </p>
        <p
          class="subheading-01-semi-bold grey-800"
          *ngIf="this.data.office.rawCommission.usd > 0"
        >
          U$S {{ (this.data.office.rawCommission.usd | number: "1.0-2") || 0 }}
        </p>
        <p
          class="subheading-01-semi-bold grey-800"
          *ngIf="this.data.office.rawCommission.local > 0"
        >
          $ {{ (this.data.office.rawCommission.local | number: "1.0-2") || 0 }}
        </p>
      </div>
    </div>

    <!-- Oficina -->
    <div
      class="agent-container summary first"
      [ngClass]="{ 'show-row': this.data.office.rawCommission.percentage > 0 }"
      *ngIf="this.data.office.rawCommission.percentage > 0"
    >
      <div
        class="summary-header"
        (click)="this.officeShow = !this.officeShow"
        [ngClass]="{ 'border-bottom': this.officeShow }"
      >
        <div class="left-info">
          <div class="icon-arrow-container">
            <div
              class="arrow-full"
              [ngClass]="{ rotate: !this.officeShow }"
            ></div>
          </div>
          <p class="caption-01-semi-bold grey-800">A cobrar oficina</p>
        </div>
        <div
          class="right-info"
          *ngIf="!this.officeShow"
          [ngClass]="{
            end:
              this.data.rawCommission.usd == 0 ||
              this.data.rawCommission.local == 0
          }"
        >
          <!-- <p
            class="caption-01-semi-bold grey-800"
            *ngIf="this.data.office.rawCommission.percentage > 0"
          >
            {{
              (this.data.office.rawCommission.percentage | number : "1.0-2") ||
                0
            }}%
          </p> -->
          <p
            class="caption-01-semi-bold grey-800"
            *ngIf="this.data.office.netCommission.usd > 0"
          >
            U$S
            {{ (this.data.office.netCommission.usd | number: "1.0-2") || 0 }}
          </p>
          <p
            class="caption-01-semi-bold grey-800"
            *ngIf="this.data.office.netCommission.local > 0"
          >
            $
            {{ (this.data.office.netCommission.local | number: "1.0-2") || 0 }}
          </p>
        </div>
      </div>
      <div
        class="full-deductions"
        [ngClass]="{ show: this.officeShow }"
        *ngIf="this.officeShow"
      >
        <div class="deductions">
          <!-- Comision Bruta Oficina -->
          <div
            class="deductions-row show-row-item"
            *ngIf="!this.data.referred.isReferred; else isreferredoffice"
          >
            <div class="titles">
              <p class="paragraph-03-regular grey-700">
                Comisión bruta de la operación
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.rawCommission.usd == 0 ||
                  this.data.rawCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.rawCommission.usd > 0"
              >
                U$S {{ (this.data.rawCommission.usd | number: "1.0-2") || 0 }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.rawCommission.local > 0"
              >
                $ {{ (this.data.rawCommission.local | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>
          <!-- Oficina referido a cobrar -->
          <ng-template #isreferredoffice>
            <div class="deductions-row show-row-item">
              <div class="titles">
                <p class="paragraph-03-regular grey-700">
                  Comisión bruta de la operación
                </p>
              </div>
              <div
                class="comissions"
                [ngClass]="{
                  end:
                    this.data.office.rawCommission.usd == 0 ||
                    this.data.office.rawCommission.local == 0
                }"
              >
                <p
                  class="paragraph-03-regular grey-700 align-right"
                  *ngIf="this.data.office.rawCommission.usd > 0"
                >
                  U$S
                  {{
                    (this.data.office.rawCommission.usd | number: "1.0-2") || 0
                  }}
                </p>
                <p
                  class="paragraph-03-regular grey-700"
                  *ngIf="this.data.office.rawCommission.local > 0"
                >
                  $
                  {{
                    (this.data.office.rawCommission.local | number: "1.0-2") ||
                      0
                  }}
                </p>
              </div>
            </div>
          </ng-template>
          <!-- Descuento punta vendedora -->
          <div
            class="deductions-row"
            *ngIf="
              this.data.seller.officeId != null ||
              this.data.seller.otherRealEstateName
            "
            [ngClass]="{
              'show-row-item':
                this.data.seller.officeId != null ||
                this.data.seller.otherRealEstateName
            }"
          >
            <div class="titles">
              <p class="paragraph-03-regular grey-700">
                Descuento: Punta
                {{ this.NODE === this.NODE_DO ? "captadora" : "vendedora" }}
                {{
                  this.data.seller.otherRealEstateName
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end: this.data.seller.usd == 0 || this.data.seller.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.seller.usd > 0"
              >
                - U$S
                {{
                  (this.data.seller.usd -
                    (this.data.seller.officeId ||
                    this.data.seller.otherRealEstateName
                      ? 0
                      : this.cobrokerUSD) | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.seller.local > 0"
              >
                - $
                {{
                  (this.data.seller.local -
                    (this.data.seller.officeId ||
                    this.data.seller.otherRealEstateName
                      ? 0
                      : this.cobrokerLocal) | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- Descuento punta compradora -->
          <div
            class="deductions-row"
            *ngIf="
              this.data.buyer.officeId != null ||
              this.data.buyer.otherRealEstateName
            "
            [ngClass]="{
              'show-row-item':
                this.data.buyer.officeId != null ||
                this.data.buyer.otherRealEstateName
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                Descuento: Punta compradora

                {{
                  this.data.buyer.otherRealEstateName
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                Descuento: Punta vendedora

                {{
                  this.data.buyer.otherRealEstateName
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end: this.data.buyer.usd == 0 || this.data.buyer.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.buyer.usd > 0"
              >
                - U$S
                {{
                  (this.data.buyer.agent.netCommission.usd | number: "1.0-2") ||
                    0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.buyer.local > 0"
              >
                - $
                {{
                  (this.data.buyer.agent.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- Descuento referido vendedor -->
          <div
            class="deductions-row"
            *ngIf="
              this.data.seller.referred.officeId &&
              this.data.seller.referred.rawCommission.percentage
            "
            [ngClass]="{
              'show-row-item':
                this.data.seller.referred.officeId &&
                this.data.seller.referred.rawCommission.percentage
            }"
          >
            <div class="titles">
              <p class="paragraph-03-regular grey-700">
                Descuento: Referido vendedor
                {{
                  this.data.seller.referred.officeId ==
                  this.data.seller.referred.name
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.seller.referred.rawCommission.usd == 0 ||
                  this.data.seller.referred.rawCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.seller.referred.rawCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.seller.referred.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.seller.referred.rawCommission.local > 0"
              >
                - $
                {{
                  (this.data.seller.referred.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>

          <ng-container
            *ngIf="
              this.data.cobrokers &&
              this.data.cobrokers.length > 0 &&
              NODE === NODE_DO &&
              this.data.seller.officeId == null &&
              !this.data.seller.otherRealEstateName
            "
          >
            <ng-container
              *ngFor="let cobroker of this.data.cobrokers; let i = index"
            >
              <ng-container
                *ngIf="
                  (cobroker.officeId !== null && cobroker.office !== '') ||
                  cobroker.otherRealEstateName
                "
              >
                <!-- Descuento referido vendedor -->
                <div
                  class="deductions-row"
                  *ngIf="
                    cobroker.rawCommission.usd > 0 ||
                    cobroker.rawCommission.local > 0
                  "
                  [ngClass]="{
                    'show-row-item':
                      cobroker.rawCommission.usd > 0 ||
                      cobroker.rawCommission.local > 0
                  }"
                >
                  <div class="titles">
                    <p class="paragraph-03-regular grey-700">
                      Descuento: Cobroker {{ i + 1 }}
                      {{
                        cobroker.otherRealEstateName
                          ? "(Otro)"
                          : "(Otro RE/MAX)"
                      }}
                    </p>
                  </div>
                  <div
                    class="comissions"
                    [ngClass]="{
                      end:
                        cobroker.rawCommission.usd == 0 ||
                        cobroker.rawCommission.local == 0
                    }"
                  >
                    <p
                      class="paragraph-03-regular grey-700 align-right"
                      *ngIf="cobroker.rawCommission.usd > 0"
                    >
                      - U$S
                      {{ (cobroker.rawCommission.usd | number: "1.0-2") || 0 }}
                    </p>
                    <p
                      class="paragraph-03-regular grey-700"
                      *ngIf="cobroker.rawCommission.local > 0"
                    >
                      - $
                      {{
                        (cobroker.rawCommission.local | number: "1.0-2") || 0
                      }}
                    </p>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- Descuento referido comprador -->
          <div
            class="deductions-row"
            *ngIf="
              this.data.buyer.referred.officeId &&
              this.data.buyer.referred.rawCommission.percentage
            "
            [ngClass]="{
              'show-row-item':
                this.data.buyer.referred.officeId &&
                this.data.buyer.referred.rawCommission.percentage
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                Descuento: Referido comprador
                {{
                  this.data.buyer.referred.officeId ==
                  this.data.buyer.referred.name
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                Descuento: Referido vendedor
                {{
                  this.data.buyer.referred.officeId ==
                  this.data.buyer.referred.name
                    ? "(Otro)"
                    : "(Otro RE/MAX)"
                }}
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.buyer.referred.rawCommission.usd == 0 ||
                  this.data.buyer.referred.rawCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.buyer.referred.rawCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.buyer.referred.rawCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.buyer.referred.rawCommission.local > 0"
              >
                - $
                {{
                  (this.data.buyer.referred.rawCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- Comision Bruta Oficina -->
          <div
            class="deductions-row subtotal show-row-item"
            *ngIf="!this.data.referred.isReferred"
          >
            <div class="titles strong">
              <p class="caption-01-semi-bold grey-800">
                Comisión bruta oficina ({{
                  (this.data.office.subtotal.percentage | number: "1.0-2") || 0
                }}%)
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.office.subtotal.usd == 0 ||
                  this.data.office.subtotal.local == 0
              }"
            >
              <p
                class="caption-01-semi-bold grey-800 align-right"
                *ngIf="this.data.office.subtotal.usd > 0"
              >
                U$S
                {{ (this.data.office.subtotal.usd | number: "1.0-2") || 0 }}
              </p>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="this.data.office.subtotal.local > 0"
              >
                $
                {{ (this.data.office.subtotal.local | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>
          <!-- A pagar agente referido a cobrar -->
          <div
            class="deductions-row show-row-item"
            *ngIf="this.data.referred.isReferred"
          >
            <div class="titles">
              <p class="paragraph-03-regular grey-700">
                A pagar agente <span class="grey-600">referido</span>
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.referred.netCommission.usd == 0 ||
                  this.data.referred.netCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.referred.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.referred.netCommission.usd | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.referred.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.referred.netCommission.local | number: "1.0-2") ||
                    0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar agente vendedor -->
          <div
            class="deductions-row"
            *ngIf="
              !this.data.referred.isReferred &&
              this.data.seller.officeId == null &&
              !this.data.seller.otherRealEstateName &&
              (this.data.seller.agent.netCommission.usd > 0 ||
                this.data.seller.agent.netCommission.local > 0)
            "
            [ngClass]="{
              'show-row-item':
                this.data.seller.officeId == null &&
                !this.data.seller.otherRealEstateName
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                A pagar agente <span class="grey-600">(vendedor)</span>
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                A pagar agente <span class="grey-600">(captador)</span>
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.seller.agent.netCommission.usd == 0 ||
                  this.data.seller.agent.netCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.seller.agent.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.seller.agent.netCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.seller.agent.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.seller.agent.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar referido vendedor -->
          <div
            class="deductions-row"
            *ngIf="
              !this.data.seller.referred.officeId &&
              this.data.seller.referred.rawCommission.percentage > 0
            "
            [ngClass]="{
              'show-row-item':
                !this.data.seller.referred.officeId &&
                this.data.seller.referred.rawCommission.percentage > 0
            }"
          >
            <p
              *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
              class="paragraph-03-regular grey-700"
            >
              A pagar referido <span class="grey-600">(vendedor)</span>
            </p>
            <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
              A pagar referido <span class="grey-600">(captador)</span>
            </p>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.seller.referred.netCommission.usd == 0 ||
                  this.data.seller.referred.netCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.seller.referred.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.seller.referred.netCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.seller.referred.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.seller.referred.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar team leader -->
          <div
            class="deductions-row"
            *ngIf="this.data.seller.teamLeader.name"
            [ngClass]="{
              'show-row-item': this.data.seller.teamLeader.name
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                A pagar team leader <span class="grey-600">(vendedor)</span>
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                A pagar team leader <span class="grey-600">(captador)</span>
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.seller.teamLeader.rawCommission.usd > 0 ||
                  this.data.seller.teamLeader.rawCommission.local > 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.seller.teamLeader.rawCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.seller.teamLeader.netCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.seller.teamLeader.rawCommission.local > 0"
              >
                - $
                {{
                  (this.data.seller.teamLeader.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar cobrokers punta vendedora -->
          <ng-container *ngIf="this.data.cobrokers.length">
            <ng-container
              *ngFor="let cobroker of this.data.cobrokers; let i = index"
            >
              <ng-container
                *ngIf="
                  !cobroker.officeId &&
                  !cobroker.otherRealEstateName &&
                  cobroker.office
                "
              >
                <div
                  class="deductions-row"
                  [ngClass]="{
                    'show-row-item':
                      cobroker.netCommission.usd > 0 ||
                      cobroker.netCommission.local > 0
                  }"
                >
                  <div class="titles">
                    <p
                      *ifNodeShow="[NODE_DO]"
                      class="paragraph-03-regular grey-700"
                    >
                      A pagar cobroker {{ i + 1 }}
                      <span class="grey-600">(captador)</span>
                    </p>
                  </div>

                  <div
                    class="comissions"
                    [ngClass]="{
                      end:
                        cobroker.netCommission.usd == 0 ||
                        cobroker.netCommission.local == 0
                    }"
                  >
                    <p
                      class="paragraph-03-regular grey-700 align-right"
                      *ngIf="cobroker.netCommission.usd > 0"
                    >
                      - U$S
                      {{ (cobroker.netCommission.usd | number: "1.0-2") || 0 }}
                    </p>
                    <p
                      class="paragraph-03-regular grey-700"
                      *ngIf="cobroker.netCommission.local > 0"
                    >
                      - $
                      {{
                        (cobroker.netCommission.local | number: "1.0-2") || 0
                      }}
                    </p>
                  </div>
                </div>

                <div
                  class="deductions-row"
                  [ngClass]="{
                    'show-row-item':
                      cobroker.teamLeader.netCommission.usd > 0 ||
                      cobroker.teamLeader.netCommission.local > 0
                  }"
                >
                  <div class="titles">
                    <p
                      *ifNodeShow="[NODE_DO]"
                      class="paragraph-03-regular grey-700"
                    >
                      A pagar teamleader cobroker {{ i + 1 }}
                      <span class="grey-600">(captador)</span>
                    </p>
                  </div>

                  <div
                    class="comissions"
                    [ngClass]="{
                      end:
                        cobroker.teamLeader.netCommission.usd == 0 ||
                        cobroker.teamLeader.netCommission.local == 0
                    }"
                  >
                    <p
                      class="paragraph-03-regular grey-700 align-right"
                      *ngIf="cobroker.teamLeader.netCommission.usd > 0"
                    >
                      - U$S
                      {{
                        (cobroker.teamLeader.netCommission.usd
                          | number: "1.0-2") || 0
                      }}
                    </p>
                    <p
                      class="paragraph-03-regular grey-700"
                      *ngIf="cobroker.teamLeader.netCommission.local > 0"
                    >
                      - $
                      {{
                        (cobroker.teamLeader.netCommission.local
                          | number: "1.0-2") || 0
                      }}
                    </p>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- A pagar agente comprador -->
          <div
            class="deductions-row"
            *ngIf="
              !this.data.referred.isReferred &&
              this.data.buyer.officeId == null &&
              !this.data.buyer.otherRealEstateName &&
              (this.data.buyer.agent.netCommission.usd > 0 ||
                this.data.buyer.agent.netCommission.local > 0)
            "
            [ngClass]="{
              'show-row-item':
                this.data.buyer.officeId == null &&
                !this.data.buyer.otherRealEstateName
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                A pagar agente <span class="grey-600">(comprador)</span>
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                A pagar agente <span class="grey-600">(vendedor)</span>
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.buyer.agent.netCommission.usd == 0 ||
                  this.data.buyer.agent.netCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.buyer.agent.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.buyer.agent.netCommission.usd | number: "1.0-2") ||
                    0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.buyer.agent.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.buyer.agent.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar referido comprador -->
          <div
            class="deductions-row"
            *ngIf="
              !this.data.buyer.referred.officeId &&
              this.data.buyer.referred.rawCommission.percentage > 0
            "
            [ngClass]="{
              'show-row-item':
                !this.data.buyer.referred.officeId &&
                this.data.buyer.referred.rawCommission.percentage > 0
            }"
          >
            <p
              *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
              class="paragraph-03-regular grey-700"
            >
              A pagar referido <span class="grey-600">(comprador)</span>
            </p>
            <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
              A pagar referido <span class="grey-600">(vendedor)</span>
            </p>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.buyer.referred.netCommission.usd == 0 ||
                  this.data.buyer.referred.netCommission.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.buyer.referred.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.buyer.referred.netCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.buyer.referred.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.buyer.referred.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- A pagar team leader -->
          <div
            class="deductions-row"
            *ngIf="this.data.buyer.teamLeader.name"
            [ngClass]="{
              'show-row-item': this.data.buyer.teamLeader.name
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                A pagar team leader <span class="grey-600">(comprador)</span>
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                A pagar team leader <span class="grey-600">(vendedor)</span>
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.buyer.teamLeader.netCommission.usd > 0 ||
                  this.data.buyer.teamLeader.netCommission.local > 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.buyer.teamLeader.netCommission.usd > 0"
              >
                - U$S
                {{
                  (this.data.buyer.teamLeader.netCommission.usd
                    | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.buyer.teamLeader.netCommission.local > 0"
              >
                - $
                {{
                  (this.data.buyer.teamLeader.netCommission.local
                    | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- Comision Neta Oficina -->
          <div
            *ngIf="NODE !== NODE_GLOBAL"
            class="deductions-row subtotal"
            [ngClass]="{
              'show-row-item':
                this.data.office.netCommission.usd > 0 ||
                this.data.office.netCommission.local > 0
            }"
          >
            <div class="titles strong">
              <p class="caption-01-semi-bold grey-800">Comisión neta</p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  (this.data.office.netCommission.usd == 0 ||
                    this.data.office.netCommission.local == 0) &&
                  (this.data.seller.usd == 0 || this.data.seller.local == 0) &&
                  (this.data.buyer.usd == 0 || this.data.buyer.local == 0)
              }"
            >
              <p
                class="caption-01-semi-bold grey-800 align-right"
                *ngIf="
                  this.data.office.netCommission.usd >= 0 &&
                  this.data.office.rawCommission.usd > 0
                "
              >
                U$S
                {{
                  (this.data.office.netCommission.usd | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="
                  this.data.office.netCommission.local >= 0 &&
                  this.data.office.rawCommission.local > 0
                "
              >
                $
                {{
                  (this.data.office.netCommission.local | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
          <!-- Comision Neta Oficina - GLOBAL -->
          <div
            *ngIf="NODE == NODE_GLOBAL"
            class="deductions-row subtotal show-row-item"
          >
            <div class="titles strong">
              <p class="caption-01-semi-bold grey-800">Comisión neta</p>
            </div>
            <div class="comissions end">
              <p
                class="caption-01-semi-bold grey-800 align-right"
                *ngIf="this.data.office.subtotal.usd > 0"
              >
                U$S
                {{
                  (this.data.office.netCommission.usd | number: "1.0-2") || 0
                }}
              </p>
              <p
                class="caption-01-semi-bold grey-800"
                *ngIf="this.data.office.subtotal.local > 0"
              >
                $
                {{
                  (this.data.office.netCommission.local | number: "1.0-2") || 0
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- ROW -->
    </div>
  </div>
  <!-- OFICINA END -->

  <!-- ESTADISTICAS -->
  <div
    class="row last"
    *ngIf="this.showStatistics"
    [ngClass]="{ 'show-row': this.showStatistics }"
  >
    <div class="row-header">
      <div class="row-titles">
        <div class="icon-container">
          <qr-icon name="bar-chart" color="primary-700"></qr-icon>
        </div>
        <p class="subheading-01-semi-bold grey-800">Estadísticas</p>
      </div>
      <div class="row-currencies">
        <qr-chip
          [config]="this.statisticsModeChip"
          [value]="this.statisticsModeLabel"
        ></qr-chip>
      </div>
    </div>

    <div class="agent-container summary first show-row">
      <div
        class="summary-header"
        (click)="this.statisticsShow = !this.statisticsShow"
        [ngClass]="{ 'border-bottom': this.statisticsShow }"
      >
        <div class="left-info">
          <div class="icon-arrow-container">
            <div
              class="arrow-full"
              [ngClass]="{ rotate: !this.statisticsShow }"
            ></div>
          </div>
          <p class="caption-01-semi-bold grey-800">Totales por agente</p>
        </div>
      </div>
      <div
        class="full-deductions"
        [ngClass]="{ show: this.statisticsShow }"
        *ngIf="this.statisticsShow"
      >
        <div class="deductions">
          <!-- Un renglon por persona -->
          <div
            class="deductions-row show-row-item statistics-agent"
            *ngFor="let row of this.data.statistics.rows"
          >
            <div class="titles">
              <p class="paragraph-03-regular grey-700">{{ row.name }}</p>
            </div>
            <div class="comissions end">
              <p class="paragraph-03-regular grey-700 align-right">
                {{ this.statisticsSign(row.usd) }}U$S
                {{ (this.statisticsAbs(row.usd) | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- ROW -->
    </div>
  </div>
  <!-- ESTADISTICAS END -->

  <!-- IVA -->
  <div
    class="row last show-row border-none"
    *ngIf="
      this.data.iva.agent.usd > 0 ||
      this.data.iva.agent.local > 0 ||
      this.data.iva.office.usd > 0 ||
      this.data.iva.office.local > 0
    "
  >
    <div class="row-header">
      <div class="row-titles">
        <div class="icon-container">
          <qr-icon name="solicitate-cae" color="primary-700"></qr-icon>
        </div>
        <p
          *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
          class="subheading-01-semi-bold grey-800"
        >
          IVA
        </p>
        <p *ifNodeShow="[NODE_DO]" class="subheading-01-semi-bold grey-800">
          ITBIS
        </p>
      </div>
    </div>

    <!-- IVA -->
    <div class="agent-container summary first show-row">
      <div class="summary-header border-bottom">
        <div class="left-info ml-16">
          <p
            *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
            class="caption-01-semi-bold grey-800"
          >
            IVAs generados por facturación
          </p>
          <p *ifNodeShow="[NODE_DO]" class="caption-01-semi-bold grey-800">
            ITBIS generados por facturación
          </p>
        </div>
      </div>
      <div class="full-deductions show">
        <div class="deductions">
          <!-- IVA oficina -->
          <div
            class="deductions-row show-row-item"
            *ngIf="
              this.data.iva.office.usd > 0 || this.data.iva.office.local > 0
            "
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                IVA oficina
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                ITBIS oficina
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.iva.office.usd == 0 ||
                  this.data.iva.office.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.iva.office.usd > 0"
              >
                U$S {{ (this.data.iva.office.usd | number: "1.0-2") || 0 }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.iva.office.local > 0"
              >
                $ {{ (this.data.iva.office.local | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>
          <!-- IVA agente -->
          <div
            class="deductions-row"
            *ngIf="this.data.iva.agent.usd > 0 || this.data.iva.agent.local > 0"
            [ngClass]="{
              'show-row-item':
                this.data.iva.agent.usd > 0 || this.data.iva.agent.local > 0
            }"
          >
            <div class="titles">
              <p
                *ifNodeShow="[NODE_AR, NODE_GLOBAL]"
                class="paragraph-03-regular grey-700"
              >
                IVA agente
              </p>
              <p *ifNodeShow="[NODE_DO]" class="paragraph-03-regular grey-700">
                ITBIS agente
              </p>
            </div>
            <div
              class="comissions"
              [ngClass]="{
                end:
                  this.data.iva.agent.usd == 0 || this.data.iva.agent.local == 0
              }"
            >
              <p
                class="paragraph-03-regular grey-700 align-right"
                *ngIf="this.data.iva.agent.usd > 0"
              >
                U$S
                {{ (this.data.iva.agent.usd | number: "1.0-2") || 0 }}
              </p>
              <p
                class="paragraph-03-regular grey-700"
                *ngIf="this.data.iva.agent.local > 0"
              >
                $
                {{ (this.data.iva.agent.local | number: "1.0-2") || 0 }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!-- ROW -->
    </div>
  </div>
  <!-- IVA END -->
</div>
